
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $706cf62f66af6222$var$xlinkNS = "http://www.w3.org/1999/xlink";
const $706cf62f66af6222$var$xmlnsNS = "http://www.w3.org/2000/xmlns/";
const $706cf62f66af6222$var$xmlNS = "http://www.w3.org/XML/1998/namespace";
const $706cf62f66af6222$var$colonChar = 58;
const $706cf62f66af6222$var$xChar = 120;
const $706cf62f66af6222$var$mChar = 109;
function $706cf62f66af6222$var$updateAttrs(oldVnode, vnode) {
    let key;
    const elm = vnode.elm;
    let oldAttrs = oldVnode.data.attrs;
    let attrs = vnode.data.attrs;
    if (!oldAttrs && !attrs) return;
    if (oldAttrs === attrs) return;
    oldAttrs = oldAttrs || {};
    attrs = attrs || {};
    // update modified attributes, add new attributes
    for(key in attrs){
        const cur = attrs[key];
        const old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, "");
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key.charCodeAt(0) !== $706cf62f66af6222$var$xChar) elm.setAttribute(key, cur);
                else if (key.charCodeAt(3) === $706cf62f66af6222$var$colonChar) // Assume xml namespace
                elm.setAttributeNS($706cf62f66af6222$var$xmlNS, key, cur);
                else if (key.charCodeAt(5) === $706cf62f66af6222$var$colonChar) // Assume 'xmlns' or 'xlink' namespace
                key.charCodeAt(1) === $706cf62f66af6222$var$mChar ? elm.setAttributeNS($706cf62f66af6222$var$xmlnsNS, key, cur) : elm.setAttributeNS($706cf62f66af6222$var$xlinkNS, key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    // remove removed attributes
    // use `in` operator since the previous `for` iteration uses it (.i.e. add even attributes with undefined value)
    // the other option is to remove all attributes with value == undefined
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
const $706cf62f66af6222$export$5381d68fac100f69 = {
    create: $706cf62f66af6222$var$updateAttrs,
    update: $706cf62f66af6222$var$updateAttrs
};

function $880fb610c7e02f7e$var$updateClass(oldVnode, vnode) {
    let cur;
    let name;
    const elm = vnode.elm;
    let oldClass = oldVnode.data.class;
    let klass = vnode.data.class;
    if (!oldClass && !klass) return;
    if (oldClass === klass) return;
    oldClass = oldClass || {};
    klass = klass || {};
    for(name in oldClass)if (oldClass[name] && !Object.prototype.hasOwnProperty.call(klass, name)) // was `true` and now not provided
    elm.classList.remove(name);
    for(name in klass){
        cur = klass[name];
        if (cur !== oldClass[name]) elm.classList[cur ? "add" : "remove"](name);
    }
}
const $880fb610c7e02f7e$export$63b0a5e02d9d5ac4 = {
    create: $880fb610c7e02f7e$var$updateClass,
    update: $880fb610c7e02f7e$var$updateClass
};

function $6fe2ed398ee32f0c$var$invokeHandler(handler, vnode, event) {
    if (typeof handler === "function") // call function handler
    handler.call(vnode, event, vnode);
    else if (typeof handler === "object") // call multiple handlers
    for(let i = 0; i < handler.length; i++)$6fe2ed398ee32f0c$var$invokeHandler(handler[i], vnode, event);
}
function $6fe2ed398ee32f0c$var$handleEvent(event, vnode) {
    const name = event.type;
    const on = vnode.data.on;
    // call event handler(s) if exists
    if (on && on[name]) $6fe2ed398ee32f0c$var$invokeHandler(on[name], vnode, event);
}
function $6fe2ed398ee32f0c$var$createListener() {
    return function handler(event) {
        $6fe2ed398ee32f0c$var$handleEvent(event, handler.vnode);
    };
}
function $6fe2ed398ee32f0c$var$updateEventListeners(oldVnode, vnode) {
    const oldOn = oldVnode.data.on;
    const oldListener = oldVnode.listener;
    const oldElm = oldVnode.elm;
    const on = vnode && vnode.data.on;
    const elm = vnode && vnode.elm;
    let name;
    // optimization for reused immutable handlers
    if (oldOn === on) return;
    // remove existing listeners which no longer used
    if (oldOn && oldListener) {
        // if element changed or deleted we remove all existing listeners unconditionally
        if (!on) for(name in oldOn)// remove listener if element was changed or existing listeners removed
        oldElm.removeEventListener(name, oldListener, false);
        else {
            for(name in oldOn)// remove listener if existing listener removed
            if (!on[name]) oldElm.removeEventListener(name, oldListener, false);
        }
    }
    // add new listeners which has not already attached
    if (on) {
        // reuse existing listener or create new
        const listener = vnode.listener = oldVnode.listener || $6fe2ed398ee32f0c$var$createListener();
        // update vnode for listener
        listener.vnode = vnode;
        // if element changed or added we add all needed listeners unconditionally
        if (!oldOn) for(name in on)// add listener if element was changed or new listeners added
        elm.addEventListener(name, listener, false);
        else {
            for(name in on)// add listener if new listener added
            if (!oldOn[name]) elm.addEventListener(name, listener, false);
        }
    }
}
const $6fe2ed398ee32f0c$export$7141f6ad17467258 = {
    create: $6fe2ed398ee32f0c$var$updateEventListeners,
    update: $6fe2ed398ee32f0c$var$updateEventListeners,
    destroy: $6fe2ed398ee32f0c$var$updateEventListeners
};

function $24eead225ad95ada$export$86f1c2e46be1e431(sel, data, children, text, elm) {
    const key = data === undefined ? undefined : data.key;
    return {
        sel: sel,
        data: data,
        children: children,
        text: text,
        elm: elm,
        key: key
    };
}


const $b7d801a10c385afd$export$2f23118c22fb2630 = Array.isArray;
function $b7d801a10c385afd$export$f371853e3c41119(s) {
    return typeof s === "string" || typeof s === "number" || s instanceof String || s instanceof Number;
}


function $3a1b6c660ae74047$export$588773bb5c18f715(data, children, sel) {
    data.ns = "http://www.w3.org/2000/svg";
    if (sel !== "foreignObject" && children !== undefined) for(let i = 0; i < children.length; ++i){
        const child = children[i];
        if (typeof child === "string") continue;
        const childData = child.data;
        if (childData !== undefined) $3a1b6c660ae74047$export$588773bb5c18f715(childData, child.children, child.sel);
    }
}
function $3a1b6c660ae74047$export$dda1d9f60106f0e9(sel, b, c) {
    let data = {};
    let children;
    let text;
    let i;
    if (c !== undefined) {
        if (b !== null) data = b;
        if ($b7d801a10c385afd$export$2f23118c22fb2630(c)) children = c;
        else if ($b7d801a10c385afd$export$f371853e3c41119(c)) text = c.toString();
        else if (c && c.sel) children = [
            c
        ];
    } else if (b !== undefined && b !== null) {
        if ($b7d801a10c385afd$export$2f23118c22fb2630(b)) children = b;
        else if ($b7d801a10c385afd$export$f371853e3c41119(b)) text = b.toString();
        else if (b && b.sel) children = [
            b
        ];
        else data = b;
    }
    if (children !== undefined) {
        for(i = 0; i < children.length; ++i)if ($b7d801a10c385afd$export$f371853e3c41119(children[i])) children[i] = (0, $24eead225ad95ada$export$86f1c2e46be1e431)(undefined, undefined, undefined, children[i], undefined);
    }
    if (sel.startsWith("svg") && (sel.length === 3 || sel[3] === "." || sel[3] === "#")) $3a1b6c660ae74047$export$588773bb5c18f715(data, children, sel);
    return (0, $24eead225ad95ada$export$86f1c2e46be1e431)(sel, data, children, text, undefined);
}
function $3a1b6c660ae74047$export$f00aeb236b6f05af(children) {
    let c;
    let text;
    if ($b7d801a10c385afd$export$2f23118c22fb2630(children)) c = children;
    else if ($b7d801a10c385afd$export$f371853e3c41119(c)) text = children;
    else if (c && c.sel) c = [
        children
    ];
    if (c !== undefined) {
        for(let i = 0; i < c.length; ++i)if ($b7d801a10c385afd$export$f371853e3c41119(c[i])) c[i] = (0, $24eead225ad95ada$export$86f1c2e46be1e431)(undefined, undefined, undefined, c[i], undefined);
    }
    return (0, $24eead225ad95ada$export$86f1c2e46be1e431)(undefined, {}, c, text, undefined);
}



function $57de61d97a692143$var$createElement(tagName, options) {
    return document.createElement(tagName, options);
}
function $57de61d97a692143$var$createElementNS(namespaceURI, qualifiedName, options) {
    return document.createElementNS(namespaceURI, qualifiedName, options);
}
function $57de61d97a692143$var$createDocumentFragment() {
    return $57de61d97a692143$var$parseFragment(document.createDocumentFragment());
}
function $57de61d97a692143$var$createTextNode(text) {
    return document.createTextNode(text);
}
function $57de61d97a692143$var$createComment(text) {
    return document.createComment(text);
}
function $57de61d97a692143$var$insertBefore(parentNode, newNode, referenceNode) {
    if ($57de61d97a692143$var$isDocumentFragment(parentNode)) {
        let node = parentNode;
        while(node && $57de61d97a692143$var$isDocumentFragment(node)){
            const fragment = $57de61d97a692143$var$parseFragment(node);
            node = fragment.parent;
        }
        parentNode = node !== null && node !== void 0 ? node : parentNode;
    }
    if ($57de61d97a692143$var$isDocumentFragment(newNode)) newNode = $57de61d97a692143$var$parseFragment(newNode, parentNode);
    if (referenceNode && $57de61d97a692143$var$isDocumentFragment(referenceNode)) referenceNode = $57de61d97a692143$var$parseFragment(referenceNode).firstChildNode;
    parentNode.insertBefore(newNode, referenceNode);
}
function $57de61d97a692143$var$removeChild(node, child) {
    node.removeChild(child);
}
function $57de61d97a692143$var$appendChild(node, child) {
    if ($57de61d97a692143$var$isDocumentFragment(child)) child = $57de61d97a692143$var$parseFragment(child, node);
    node.appendChild(child);
}
function $57de61d97a692143$var$parentNode(node) {
    if ($57de61d97a692143$var$isDocumentFragment(node)) {
        while(node && $57de61d97a692143$var$isDocumentFragment(node)){
            const fragment = $57de61d97a692143$var$parseFragment(node);
            node = fragment.parent;
        }
        return node !== null && node !== void 0 ? node : null;
    }
    return node.parentNode;
}
function $57de61d97a692143$var$nextSibling(node) {
    var _a;
    if ($57de61d97a692143$var$isDocumentFragment(node)) {
        const fragment = $57de61d97a692143$var$parseFragment(node);
        const parent = $57de61d97a692143$var$parentNode(fragment);
        if (parent && fragment.lastChildNode) {
            const children = Array.from(parent.childNodes);
            const index = children.indexOf(fragment.lastChildNode);
            return (_a = children[index + 1]) !== null && _a !== void 0 ? _a : null;
        }
        return null;
    }
    return node.nextSibling;
}
function $57de61d97a692143$var$tagName(elm) {
    return elm.tagName;
}
function $57de61d97a692143$var$setTextContent(node, text) {
    node.textContent = text;
}
function $57de61d97a692143$var$getTextContent(node) {
    return node.textContent;
}
function $57de61d97a692143$var$isElement(node) {
    return node.nodeType === 1;
}
function $57de61d97a692143$var$isText(node) {
    return node.nodeType === 3;
}
function $57de61d97a692143$var$isComment(node) {
    return node.nodeType === 8;
}
function $57de61d97a692143$var$isDocumentFragment(node) {
    return node.nodeType === 11;
}
function $57de61d97a692143$var$parseFragment(fragmentNode, parentNode) {
    var _a, _b, _c;
    const fragment = fragmentNode;
    (_a = fragment.parent) !== null && _a !== void 0 ? _a : fragment.parent = parentNode !== null && parentNode !== void 0 ? parentNode : null;
    (_b = fragment.firstChildNode) !== null && _b !== void 0 ? _b : fragment.firstChildNode = fragmentNode.firstChild;
    (_c = fragment.lastChildNode) !== null && _c !== void 0 ? _c : fragment.lastChildNode = fragmentNode.lastChild;
    return fragment;
}
const $57de61d97a692143$export$b5620185d61e7315 = {
    createElement: $57de61d97a692143$var$createElement,
    createElementNS: $57de61d97a692143$var$createElementNS,
    createTextNode: $57de61d97a692143$var$createTextNode,
    createDocumentFragment: $57de61d97a692143$var$createDocumentFragment,
    createComment: $57de61d97a692143$var$createComment,
    insertBefore: $57de61d97a692143$var$insertBefore,
    removeChild: $57de61d97a692143$var$removeChild,
    appendChild: $57de61d97a692143$var$appendChild,
    parentNode: $57de61d97a692143$var$parentNode,
    nextSibling: $57de61d97a692143$var$nextSibling,
    tagName: $57de61d97a692143$var$tagName,
    setTextContent: $57de61d97a692143$var$setTextContent,
    getTextContent: $57de61d97a692143$var$getTextContent,
    isElement: $57de61d97a692143$var$isElement,
    isText: $57de61d97a692143$var$isText,
    isComment: $57de61d97a692143$var$isComment,
    isDocumentFragment: $57de61d97a692143$var$isDocumentFragment
};


const $620367a6578b1d01$var$emptyNode = (0, $24eead225ad95ada$export$86f1c2e46be1e431)("", {}, [], undefined, undefined);
function $620367a6578b1d01$var$sameVnode(vnode1, vnode2) {
    var _a, _b;
    const isSameKey = vnode1.key === vnode2.key;
    const isSameIs = ((_a = vnode1.data) === null || _a === void 0 ? void 0 : _a.is) === ((_b = vnode2.data) === null || _b === void 0 ? void 0 : _b.is);
    const isSameSel = vnode1.sel === vnode2.sel;
    const isSameTextOrFragment = !vnode1.sel && vnode1.sel === vnode2.sel ? typeof vnode1.text === typeof vnode2.text : true;
    return isSameSel && isSameKey && isSameIs && isSameTextOrFragment;
}
/**
 * @todo Remove this function when the document fragment is considered stable.
 */ function $620367a6578b1d01$var$documentFragmentIsNotSupported() {
    throw new Error("The document fragment is not supported on this platform.");
}
function $620367a6578b1d01$var$isElement(api, vnode) {
    return api.isElement(vnode);
}
function $620367a6578b1d01$var$isDocumentFragment(api, vnode) {
    return api.isDocumentFragment(vnode);
}
function $620367a6578b1d01$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var _a;
    const map = {};
    for(let i = beginIdx; i <= endIdx; ++i){
        const key = (_a = children[i]) === null || _a === void 0 ? void 0 : _a.key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
const $620367a6578b1d01$var$hooks = [
    "create",
    "update",
    "remove",
    "destroy",
    "pre",
    "post"
];
function $620367a6578b1d01$export$2cd8252107eb640b(modules, domApi, options) {
    const cbs = {
        create: [],
        update: [],
        remove: [],
        destroy: [],
        pre: [],
        post: []
    };
    const api = domApi !== undefined ? domApi : (0, $57de61d97a692143$export$b5620185d61e7315);
    for (const hook of $620367a6578b1d01$var$hooks)for (const module of modules){
        const currentHook = module[hook];
        if (currentHook !== undefined) cbs[hook].push(currentHook);
    }
    function emptyNodeAt(elm) {
        const id = elm.id ? "#" + elm.id : "";
        // elm.className doesn't return a string when elm is an SVG element inside a shadowRoot.
        // https://stackoverflow.com/questions/29454340/detecting-classname-of-svganimatedstring
        const classes = elm.getAttribute("class");
        const c = classes ? "." + classes.split(" ").join(".") : "";
        return (0, $24eead225ad95ada$export$86f1c2e46be1e431)(api.tagName(elm).toLowerCase() + id + c, {}, [], undefined, elm);
    }
    function emptyDocumentFragmentAt(frag) {
        return (0, $24eead225ad95ada$export$86f1c2e46be1e431)(undefined, {}, [], undefined, frag);
    }
    function createRmCb(childElm, listeners) {
        return function rmCb() {
            if (--listeners === 0) {
                const parent = api.parentNode(childElm);
                if (parent !== null) api.removeChild(parent, childElm);
            }
        };
    }
    function createElm(vnode, insertedVnodeQueue) {
        var _a, _b, _c, _d, _e;
        let i;
        const data = vnode.data;
        const hook = data === null || data === void 0 ? void 0 : data.hook;
        (_a = hook === null || hook === void 0 ? void 0 : hook.init) === null || _a === void 0 || _a.call(hook, vnode);
        const children = vnode.children;
        const sel = vnode.sel;
        if (sel === "!") {
            (_b = vnode.text) !== null && _b !== void 0 ? _b : vnode.text = "";
            vnode.elm = api.createComment(vnode.text);
        } else if (sel === "") // textNode has no selector
        vnode.elm = api.createTextNode(vnode.text);
        else if (sel !== undefined) {
            // Parse selector
            const hashIdx = sel.indexOf("#");
            const dotIdx = sel.indexOf(".", hashIdx);
            const hash = hashIdx > 0 ? hashIdx : sel.length;
            const dot = dotIdx > 0 ? dotIdx : sel.length;
            const tag = hashIdx !== -1 || dotIdx !== -1 ? sel.slice(0, Math.min(hash, dot)) : sel;
            const ns = data === null || data === void 0 ? void 0 : data.ns;
            const elm = ns === undefined ? api.createElement(tag, data) : api.createElementNS(ns, tag, data);
            vnode.elm = elm;
            if (hash < dot) elm.setAttribute("id", sel.slice(hash + 1, dot));
            if (dotIdx > 0) elm.setAttribute("class", sel.slice(dot + 1).replace(/\./g, " "));
            for(i = 0; i < cbs.create.length; ++i)cbs.create[i]($620367a6578b1d01$var$emptyNode, vnode);
            if ($b7d801a10c385afd$export$f371853e3c41119(vnode.text) && (!$b7d801a10c385afd$export$2f23118c22fb2630(children) || children.length === 0)) // allow h1 and similar nodes to be created w/ text and empty child list
            api.appendChild(elm, api.createTextNode(vnode.text));
            if ($b7d801a10c385afd$export$2f23118c22fb2630(children)) for(i = 0; i < children.length; ++i){
                const ch = children[i];
                if (ch != null) api.appendChild(elm, createElm(ch, insertedVnodeQueue));
            }
            if (hook !== undefined) {
                (_c = hook.create) === null || _c === void 0 || _c.call(hook, $620367a6578b1d01$var$emptyNode, vnode);
                if (hook.insert !== undefined) insertedVnodeQueue.push(vnode);
            }
        } else if (((_d = options === null || options === void 0 ? void 0 : options.experimental) === null || _d === void 0 ? void 0 : _d.fragments) && vnode.children) {
            vnode.elm = ((_e = api.createDocumentFragment) !== null && _e !== void 0 ? _e : $620367a6578b1d01$var$documentFragmentIsNotSupported)();
            for(i = 0; i < cbs.create.length; ++i)cbs.create[i]($620367a6578b1d01$var$emptyNode, vnode);
            for(i = 0; i < vnode.children.length; ++i){
                const ch = vnode.children[i];
                if (ch != null) api.appendChild(vnode.elm, createElm(ch, insertedVnodeQueue));
            }
        } else vnode.elm = api.createTextNode(vnode.text);
        return vnode.elm;
    }
    function addVnodes(parentElm, before, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for(; startIdx <= endIdx; ++startIdx){
            const ch = vnodes[startIdx];
            if (ch != null) api.insertBefore(parentElm, createElm(ch, insertedVnodeQueue), before);
        }
    }
    function invokeDestroyHook(vnode) {
        var _a, _b;
        const data = vnode.data;
        if (data !== undefined) {
            (_b = (_a = data === null || data === void 0 ? void 0 : data.hook) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 || _b.call(_a, vnode);
            for(let i = 0; i < cbs.destroy.length; ++i)cbs.destroy[i](vnode);
            if (vnode.children !== undefined) for(let j = 0; j < vnode.children.length; ++j){
                const child = vnode.children[j];
                if (child != null && typeof child !== "string") invokeDestroyHook(child);
            }
        }
    }
    function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
        var _a, _b;
        for(; startIdx <= endIdx; ++startIdx){
            let listeners;
            const ch = vnodes[startIdx];
            if (ch != null) {
                if (ch.sel !== undefined) {
                    invokeDestroyHook(ch);
                    listeners = cbs.remove.length + 1;
                    const rm = createRmCb(ch.elm, listeners);
                    for(let i = 0; i < cbs.remove.length; ++i)cbs.remove[i](ch, rm);
                    const removeHook = (_b = (_a = ch === null || ch === void 0 ? void 0 : ch.data) === null || _a === void 0 ? void 0 : _a.hook) === null || _b === void 0 ? void 0 : _b.remove;
                    if (removeHook !== undefined) removeHook(ch, rm);
                    else rm();
                } else if (ch.children) {
                    // Fragment node
                    invokeDestroyHook(ch);
                    removeVnodes(parentElm, ch.children, 0, ch.children.length - 1);
                } else // Text node
                api.removeChild(parentElm, ch.elm);
            }
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue) {
        let oldStartIdx = 0;
        let newStartIdx = 0;
        let oldEndIdx = oldCh.length - 1;
        let oldStartVnode = oldCh[0];
        let oldEndVnode = oldCh[oldEndIdx];
        let newEndIdx = newCh.length - 1;
        let newStartVnode = newCh[0];
        let newEndVnode = newCh[newEndIdx];
        let oldKeyToIdx;
        let idxInOld;
        let elmToMove;
        let before;
        while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
            if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx]; // Vnode might have been moved left
            else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
            else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
            else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
            else if ($620367a6578b1d01$var$sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            } else if ($620367a6578b1d01$var$sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($620367a6578b1d01$var$sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldStartVnode.elm, api.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($620367a6578b1d01$var$sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            } else {
                if (oldKeyToIdx === undefined) oldKeyToIdx = $620367a6578b1d01$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = oldKeyToIdx[newStartVnode.key];
                if (idxInOld === undefined) {
                    // `newStartVnode` is new, create and insert it in beginning
                    api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    newStartVnode = newCh[++newStartIdx];
                } else if (oldKeyToIdx[newEndVnode.key] === undefined) {
                    // `newEndVnode` is new, create and insert it in the end
                    api.insertBefore(parentElm, createElm(newEndVnode, insertedVnodeQueue), api.nextSibling(oldEndVnode.elm));
                    newEndVnode = newCh[--newEndIdx];
                } else {
                    // Neither of the new endpoints are new vnodes, so we make progress by
                    // moving `newStartVnode` into position
                    elmToMove = oldCh[idxInOld];
                    if (elmToMove.sel !== newStartVnode.sel) api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    else {
                        patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
                        oldCh[idxInOld] = undefined;
                        api.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
                    }
                    newStartVnode = newCh[++newStartIdx];
                }
            }
        }
        if (newStartIdx <= newEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        }
        if (oldStartIdx <= oldEndIdx) removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const hook = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.hook;
        (_b = hook === null || hook === void 0 ? void 0 : hook.prepatch) === null || _b === void 0 || _b.call(hook, oldVnode, vnode);
        const elm = vnode.elm = oldVnode.elm;
        if (oldVnode === vnode) return;
        if (vnode.data !== undefined || vnode.text !== undefined && vnode.text !== oldVnode.text) {
            (_c = vnode.data) !== null && _c !== void 0 ? _c : vnode.data = {};
            (_d = oldVnode.data) !== null && _d !== void 0 ? _d : oldVnode.data = {};
            for(let i = 0; i < cbs.update.length; ++i)cbs.update[i](oldVnode, vnode);
            (_g = (_f = (_e = vnode.data) === null || _e === void 0 ? void 0 : _e.hook) === null || _f === void 0 ? void 0 : _f.update) === null || _g === void 0 || _g.call(_f, oldVnode, vnode);
        }
        const oldCh = oldVnode.children;
        const ch = vnode.children;
        if (vnode.text === undefined) {
            if (oldCh !== undefined && ch !== undefined) {
                if (oldCh !== ch) updateChildren(elm, oldCh, ch, insertedVnodeQueue);
            } else if (ch !== undefined) {
                if (oldVnode.text !== undefined) api.setTextContent(elm, "");
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            } else if (oldCh !== undefined) removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            else if (oldVnode.text !== undefined) api.setTextContent(elm, "");
        } else if (oldVnode.text !== vnode.text) {
            if (oldCh !== undefined) removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            api.setTextContent(elm, vnode.text);
        }
        (_h = hook === null || hook === void 0 ? void 0 : hook.postpatch) === null || _h === void 0 || _h.call(hook, oldVnode, vnode);
    }
    return function patch(oldVnode, vnode) {
        let i, elm, parent;
        const insertedVnodeQueue = [];
        for(i = 0; i < cbs.pre.length; ++i)cbs.pre[i]();
        if ($620367a6578b1d01$var$isElement(api, oldVnode)) oldVnode = emptyNodeAt(oldVnode);
        else if ($620367a6578b1d01$var$isDocumentFragment(api, oldVnode)) oldVnode = emptyDocumentFragmentAt(oldVnode);
        if ($620367a6578b1d01$var$sameVnode(oldVnode, vnode)) patchVnode(oldVnode, vnode, insertedVnodeQueue);
        else {
            elm = oldVnode.elm;
            parent = api.parentNode(elm);
            createElm(vnode, insertedVnodeQueue);
            if (parent !== null) {
                api.insertBefore(parent, vnode.elm, api.nextSibling(elm));
                removeVnodes(parent, [
                    oldVnode
                ], 0, 0);
            }
        }
        for(i = 0; i < insertedVnodeQueue.length; ++i)insertedVnodeQueue[i].data.hook.insert(insertedVnodeQueue[i]);
        for(i = 0; i < cbs.post.length; ++i)cbs.post[i]();
        return vnode;
    };
}

function $fce40baec9bd8542$var$updateProps(oldVnode, vnode) {
    let key;
    let cur;
    let old;
    const elm = vnode.elm;
    let oldProps = oldVnode.data.props;
    let props = vnode.data.props;
    if (!oldProps && !props) return;
    if (oldProps === props) return;
    oldProps = oldProps || {};
    props = props || {};
    for(key in props){
        cur = props[key];
        old = oldProps[key];
        if (old !== cur && (key !== "value" || elm[key] !== cur)) elm[key] = cur;
    }
}
const $fce40baec9bd8542$export$d0f594d8c58ce469 = {
    create: $fce40baec9bd8542$var$updateProps,
    update: $fce40baec9bd8542$var$updateProps
};

// Binding `requestAnimationFrame` like this fixes a bug in IE/Edge. See #360 and #409.
const $dc6bb75530089693$var$raf = typeof (window === null || window === void 0 ? void 0 : window.requestAnimationFrame) === "function" ? window.requestAnimationFrame.bind(window) : setTimeout;
const $dc6bb75530089693$var$nextFrame = (fn)=>{
    $dc6bb75530089693$var$raf(()=>{
        $dc6bb75530089693$var$raf(fn);
    });
};
let $dc6bb75530089693$var$reflowForced = false;
function $dc6bb75530089693$var$setNextFrame(obj, prop, val) {
    $dc6bb75530089693$var$nextFrame(()=>{
        obj[prop] = val;
    });
}
function $dc6bb75530089693$var$updateStyle(oldVnode, vnode) {
    let cur;
    let name;
    const elm = vnode.elm;
    let oldStyle = oldVnode.data.style;
    let style = vnode.data.style;
    if (!oldStyle && !style) return;
    if (oldStyle === style) return;
    oldStyle = oldStyle || {};
    style = style || {};
    const oldHasDel = "delayed" in oldStyle;
    for(name in oldStyle)if (!(name in style)) {
        if (name[0] === "-" && name[1] === "-") elm.style.removeProperty(name);
        else elm.style[name] = "";
    }
    for(name in style){
        cur = style[name];
        if (name === "delayed" && style.delayed) for(const name2 in style.delayed){
            cur = style.delayed[name2];
            if (!oldHasDel || cur !== oldStyle.delayed[name2]) $dc6bb75530089693$var$setNextFrame(elm.style, name2, cur);
        }
        else if (name !== "remove" && cur !== oldStyle[name]) {
            if (name[0] === "-" && name[1] === "-") elm.style.setProperty(name, cur);
            else elm.style[name] = cur;
        }
    }
}
function $dc6bb75530089693$var$applyDestroyStyle(vnode) {
    let style;
    let name;
    const elm = vnode.elm;
    const s = vnode.data.style;
    if (!s || !(style = s.destroy)) return;
    for(name in style)elm.style[name] = style[name];
}
function $dc6bb75530089693$var$applyRemoveStyle(vnode, rm) {
    const s = vnode.data.style;
    if (!s || !s.remove) {
        rm();
        return;
    }
    if (!$dc6bb75530089693$var$reflowForced) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        vnode.elm.offsetLeft;
        $dc6bb75530089693$var$reflowForced = true;
    }
    let name;
    const elm = vnode.elm;
    let i = 0;
    const style = s.remove;
    let amount = 0;
    const applied = [];
    for(name in style){
        applied.push(name);
        elm.style[name] = style[name];
    }
    const compStyle = getComputedStyle(elm);
    const props = compStyle["transition-property"].split(", ");
    for(; i < props.length; ++i)if (applied.indexOf(props[i]) !== -1) amount++;
    elm.addEventListener("transitionend", (ev)=>{
        if (ev.target === elm) --amount;
        if (amount === 0) rm();
    });
}
function $dc6bb75530089693$var$forceReflow() {
    $dc6bb75530089693$var$reflowForced = false;
}
const $dc6bb75530089693$export$8f225d2f409cea76 = {
    pre: $dc6bb75530089693$var$forceReflow,
    create: $dc6bb75530089693$var$updateStyle,
    update: $dc6bb75530089693$var$updateStyle,
    destroy: $dc6bb75530089693$var$applyDestroyStyle,
    remove: $dc6bb75530089693$var$applyRemoveStyle
};


function $fdc67a18b10ec7b1$var$copyToThunk(vnode, thunk) {
    var _a;
    const ns = (_a = thunk.data) === null || _a === void 0 ? void 0 : _a.ns;
    vnode.data.fn = thunk.data.fn;
    vnode.data.args = thunk.data.args;
    thunk.data = vnode.data;
    thunk.children = vnode.children;
    thunk.text = vnode.text;
    thunk.elm = vnode.elm;
    if (ns) (0, $3a1b6c660ae74047$export$588773bb5c18f715)(thunk.data, thunk.children, thunk.sel);
}
function $fdc67a18b10ec7b1$var$init(thunk) {
    const cur = thunk.data;
    const vnode = cur.fn(...cur.args);
    $fdc67a18b10ec7b1$var$copyToThunk(vnode, thunk);
}
function $fdc67a18b10ec7b1$var$prepatch(oldVnode, thunk) {
    let i;
    const old = oldVnode.data;
    const cur = thunk.data;
    const oldArgs = old.args;
    const args = cur.args;
    if (old.fn !== cur.fn || oldArgs.length !== args.length) {
        $fdc67a18b10ec7b1$var$copyToThunk(cur.fn(...args), thunk);
        return;
    }
    for(i = 0; i < args.length; ++i)if (oldArgs[i] !== args[i]) {
        $fdc67a18b10ec7b1$var$copyToThunk(cur.fn(...args), thunk);
        return;
    }
    $fdc67a18b10ec7b1$var$copyToThunk(oldVnode, thunk);
}
const $fdc67a18b10ec7b1$export$dd164f5517779f15 = function thunk(sel, key, fn, args) {
    if (args === undefined) {
        args = fn;
        fn = key;
        key = undefined;
    }
    return (0, $3a1b6c660ae74047$export$dda1d9f60106f0e9)(sel, {
        key: key,
        hook: {
            init: $fdc67a18b10ec7b1$var$init,
            prepatch: $fdc67a18b10ec7b1$var$prepatch
        },
        fn: fn,
        args: args
    });
};


var $37e7cd5079eb8c7d$exports = {};
'use strict';
Object.defineProperty($37e7cd5079eb8c7d$exports, '__esModule', {
    value: true
});
var $37e7cd5079eb8c7d$var$isValidString = function isValidString(param) {
    return typeof param === 'string' && param.length > 0;
};
var $37e7cd5079eb8c7d$var$startsWith = function startsWith(string, start) {
    return string[0] === start;
};
var $37e7cd5079eb8c7d$var$isSelector = function isSelector(param) {
    return $37e7cd5079eb8c7d$var$isValidString(param) && ($37e7cd5079eb8c7d$var$startsWith(param, '.') || $37e7cd5079eb8c7d$var$startsWith(param, '#'));
};
var $37e7cd5079eb8c7d$var$node = function node(h) {
    return function(tagName) {
        return function(first) {
            for(var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
            if ($37e7cd5079eb8c7d$var$isSelector(first)) return h.apply(undefined, [
                tagName + first
            ].concat(rest));
            else if (typeof first === 'undefined') return h(tagName);
            else return h.apply(undefined, [
                tagName,
                first
            ].concat(rest));
        };
    };
};
var $37e7cd5079eb8c7d$var$TAG_NAMES = [
    'a',
    'abbr',
    'acronym',
    'address',
    'applet',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'basefont',
    'bdi',
    'bdo',
    'bgsound',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'command',
    'content',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'image',
    'img',
    'input',
    'ins',
    'isindex',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'listing',
    'main',
    'map',
    'mark',
    'marquee',
    'math',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'multicol',
    'nav',
    'nextid',
    'nobr',
    'noembed',
    'noframes',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'plaintext',
    'pre',
    'progress',
    'q',
    'rb',
    'rbc',
    'rp',
    'rt',
    'rtc',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'shadow',
    'slot',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'svg',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'xmp'
];
$37e7cd5079eb8c7d$exports['default'] = function(h) {
    var createTag = $37e7cd5079eb8c7d$var$node(h);
    var exported = {
        TAG_NAMES: $37e7cd5079eb8c7d$var$TAG_NAMES,
        isSelector: $37e7cd5079eb8c7d$var$isSelector,
        createTag: createTag
    };
    $37e7cd5079eb8c7d$var$TAG_NAMES.forEach(function(n) {
        exported[n] = createTag(n);
    });
    return exported;
};
$37e7cd5079eb8c7d$exports = $37e7cd5079eb8c7d$exports['default'];


let $f6a8f99a7469fbef$var$inViewExecution = false;
function $f6a8f99a7469fbef$export$ee8240ad80d3fc2c(value) {
    $f6a8f99a7469fbef$var$inViewExecution = value;
}
function $f6a8f99a7469fbef$export$7c73462e0d25e514(renderFn, key) {
    if ($f6a8f99a7469fbef$var$inViewExecution) throw new Error("memo() must be called at module level, not inside a view function");
    let propKeys = null;
    let latestProps;
    let cachedSelector;
    let firstVNode;
    // Returns the cached first VNode on the initial snabbdom `init` hook call to avoid a double-render,
    // then delegates to renderFn for all subsequent calls
    const stableRenderFn = ()=>{
        if (firstVNode) {
            const vnode = firstVNode;
            firstVNode = undefined;
            return vnode;
        }
        return renderFn(latestProps);
    };
    return (props)=>{
        if (!propKeys) propKeys = Object.keys(props);
        latestProps = props;
        const dependencies = propKeys.map((k)=>props[k]);
        if (!cachedSelector) {
            firstVNode = renderFn(props);
            if (!firstVNode.sel) throw new Error("memo: renderFn must return a VNode with a selector (e.g. ul, div#id)");
            cachedSelector = firstVNode.sel;
        } else if (firstVNode) // Props updated again before snabbdom consumed firstVNode — discard the stale cached render
        firstVNode = undefined;
        // thunk(selector, key, renderFn, [stateArguments])
        // https://github.com/snabbdom/snabbdom?tab=readme-ov-file#thunks
        // `selector` e.g. `div#container.bar.baz` – A div element with the id container and the classes bar and baz
        // `key` is optional, it should be supplied when the selector is not unique among the thunk's siblings
        // `renderFn` is invoked only if the renderFn is changed or stateArguments change
        // `stateArguments` is an array of dependencies that are used to determine if the thunk should be re-rendered
        return (0, $fdc67a18b10ec7b1$export$dd164f5517779f15)(cachedSelector, key, stableRenderFn, dependencies);
    };
}
const $f6a8f99a7469fbef$export$b76953f99ab2be78 = (0, $620367a6578b1d01$export$2cd8252107eb640b)([
    (0, $880fb610c7e02f7e$export$63b0a5e02d9d5ac4),
    (0, $706cf62f66af6222$export$5381d68fac100f69),
    (0, $fce40baec9bd8542$export$d0f594d8c58ce469),
    (0, $6fe2ed398ee32f0c$export$7141f6ad17467258),
    (0, $dc6bb75530089693$export$8f225d2f409cea76)
]);
const $f6a8f99a7469fbef$export$c0bb0b647f701bb5 = (0, (/*@__PURE__*/$parcel$interopDefault($37e7cd5079eb8c7d$exports)))((0, $3a1b6c660ae74047$export$dda1d9f60106f0e9));
function $f6a8f99a7469fbef$export$5833d9be8010042a(vnode, hookName, callback) {
    // See https://github.com/snabbdom/snabbdom#hooks
    if (vnode) {
        vnode.data = vnode.data || {};
        vnode.data.hook = vnode.data.hook || {};
        const existing = vnode.data.hook[hookName];
        if (existing) {
            // Compose with any previously set hook on the same name.
            // Hooks have varying arity (0–2 args) so we forward arguments dynamically.
            const prev = existing;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
            vnode.data.hook[hookName] = function() {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
                prev.apply(this, arguments);
                callback();
            };
        } else vnode.data.hook[hookName] = callback;
    }
    return vnode;
}


/*
Logging for cr-26 lifecycle with Redux DevTools integration
*/ let $8a38739c2dd2509d$var$groupId = "";
// Logging controls based on URL query parameters
const $8a38739c2dd2509d$var$searchParams = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;
const $8a38739c2dd2509d$var$logToConsole = $8a38739c2dd2509d$var$searchParams?.get("debug") === "console"; // Enable with ?debug=console
const $8a38739c2dd2509d$var$logEnabled = $8a38739c2dd2509d$var$logToConsole;
let $8a38739c2dd2509d$var$devToolsConnection = null;
// Initialize Redux DevTools connection (if extension is active)
if (typeof window !== "undefined") {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
    if (devToolsExtension) {
        $8a38739c2dd2509d$var$devToolsConnection = devToolsExtension.connect({
            name: "cr-26 App",
            features: {
                jump: false,
                skip: false,
                reorder: false,
                dispatch: false,
                persist: false // Disable persist
            }
        });
        // Initialize with empty state
        if ($8a38739c2dd2509d$var$devToolsConnection) $8a38739c2dd2509d$var$devToolsConnection.init({});
    }
}
// Helper to get aggregated state for DevTools
function $8a38739c2dd2509d$var$getAggregatedState() {
    // Return a shallow copy to avoid mutating window.state
    return {
        ...window.state || {}
    };
}
const $8a38739c2dd2509d$export$bef1f36f5486a6a3 = {
    setStateGlobal (id, state) {
        // Maintain global state registry (DevTools and logging rely on this)
        // Called after actions update state and during render lifecycle
        const stateGlobal = window.state || (window.state = {});
        if (state === undefined || state === null) delete stateGlobal[id];
        else stateGlobal[id] = state;
    // Note: State updates are sent to DevTools by updateStart, not here
    // This just maintains window.state for getAggregatedState() to read
    },
    noInitialAction (id, state) {
        // Send initial mount to Redux DevTools
        if ($8a38739c2dd2509d$var$devToolsConnection && state) {
            // Build aggregated state with the initial state for this component
            const aggregatedState = $8a38739c2dd2509d$var$getAggregatedState();
            aggregatedState[id] = state;
            $8a38739c2dd2509d$var$devToolsConnection.send({
                type: `${id}/[Mount]`,
                meta: {
                    lifecycle: true
                }
            }, aggregatedState);
        }
        // Console logging
        if ($8a38739c2dd2509d$var$logEnabled) {
            if ($8a38739c2dd2509d$var$groupId) console.groupEnd();
            console.group(`%c#${id}`, "color: #69f");
            if (state) console.log(`${JSON.stringify(state)}`);
            $8a38739c2dd2509d$var$groupId = id;
        }
    },
    updateStart (id, state, label, data, newState, hasStateConfig) {
        // Send to Redux DevTools with current state
        if ($8a38739c2dd2509d$var$devToolsConnection && newState !== undefined) {
            // Update window.state FIRST so subsequent getAggregatedState() calls are accurate
            const stateGlobal = window.state || (window.state = {});
            stateGlobal[id] = newState;
            // Build aggregated state with the NEW state for this component
            const aggregatedState = $8a38739c2dd2509d$var$getAggregatedState();
            $8a38739c2dd2509d$var$devToolsConnection.send({
                type: `${id}/${label}`,
                payload: data || null
            }, aggregatedState);
        }
        // Console logging
        if ($8a38739c2dd2509d$var$logEnabled) {
            if ($8a38739c2dd2509d$var$groupId !== id) {
                if ($8a38739c2dd2509d$var$groupId) console.groupEnd();
                console.group(`%c#${id}`, "color: #69f");
                $8a38739c2dd2509d$var$groupId = id;
            }
            if (state) console.log(`%c${JSON.stringify(state)}`, "text-decoration: line-through;");
            let msg = `${String(label)}`;
            if (data) msg += ` ${JSON.stringify(data)}`;
            console.log(`%c${msg}`, "color: #f6b");
            if (!state && hasStateConfig) console.log(`No change`);
        }
    },
    updateEnd (state) {
        // Note: updateEnd is informational only - state already sent in updateStart
        // Console logging
        if ($8a38739c2dd2509d$var$logEnabled && state) console.log(`${JSON.stringify(state)}`);
    },
    taskPerform (id, label, isPromise) {
        // Send task start to Redux DevTools
        if ($8a38739c2dd2509d$var$devToolsConnection) $8a38739c2dd2509d$var$devToolsConnection.send({
            type: `${id}/[Task] ${label}/start`,
            meta: {
                isTask: true,
                status: "start",
                isPromise: isPromise
            }
        }, $8a38739c2dd2509d$var$getAggregatedState());
        // Console logging
        if ($8a38739c2dd2509d$var$logEnabled) console.log(`%cTask "${label}" perform${isPromise ? "..." : "ed"}`, "color: #dd8");
    },
    taskSuccess (id, label) {
        // Send to Redux DevTools
        if ($8a38739c2dd2509d$var$devToolsConnection) $8a38739c2dd2509d$var$devToolsConnection.send({
            type: `${id}/[Task] ${label}/success`,
            meta: {
                isTask: true,
                status: "success"
            }
        }, $8a38739c2dd2509d$var$getAggregatedState());
        // Console logging
        if ($8a38739c2dd2509d$var$logEnabled) console.log(`%c\n...#${id} task "${label}" success`, "color: #dd8");
    },
    taskFailure (id, label, err) {
        // Send to Redux DevTools
        if ($8a38739c2dd2509d$var$devToolsConnection) $8a38739c2dd2509d$var$devToolsConnection.send({
            type: `${id}/[Task] ${label}/failure`,
            payload: {
                error: err && typeof err === "object" && "message" in err ? err.message : String(err)
            },
            meta: {
                isTask: true,
                status: "failure"
            }
        }, $8a38739c2dd2509d$var$getAggregatedState());
        // Console logging
        if ($8a38739c2dd2509d$var$logEnabled) {
            console.log(`%c\n...#${id} task "${label}" failure`, "color: #dd8");
            if (err) console.error(JSON.stringify(err));
        }
    },
    render (id, props) {
        // Console logging
        if ($8a38739c2dd2509d$var$logEnabled) {
            console.groupEnd();
            let msg = `\u{27F3} Render #${id}`;
            if (props && Object.keys(props).length) msg += `, props: ${JSON.stringify(props, $8a38739c2dd2509d$var$replacer)}`;
            console.log(`%c${msg}`, "color: #888");
            $8a38739c2dd2509d$var$groupId = "";
        }
    },
    midRenderStateChange (id, props) {
        // Send to Redux DevTools when a child action changes state during the parent's view call
        if ($8a38739c2dd2509d$var$devToolsConnection) $8a38739c2dd2509d$var$devToolsConnection.send({
            type: `[Re-render: mid-render state change] #${id}`,
            meta: {
                isRerender: true
            }
        }, $8a38739c2dd2509d$var$getAggregatedState());
        // Console logging
        if ($8a38739c2dd2509d$var$logEnabled) {
            console.groupEnd();
            let msg = `\u{21BA} Re-render #${id} due to mid-render state change`;
            if (props && Object.keys(props).length) msg += `, props: ${JSON.stringify(props, $8a38739c2dd2509d$var$replacer)}`;
            console.log(`%c${msg}`, "color: #a8d");
            $8a38739c2dd2509d$var$groupId = "";
        }
    },
    patch () {
        // Console logging only — announces the patch before it executes
        if ($8a38739c2dd2509d$var$logEnabled) {
            console.log(`%c\xbb PATCH`, "color: #888");
            console.groupEnd();
        }
    },
    patchComplete () {
        // Send to Redux DevTools after the VDOM patch has fully executed.
        // Destroy hooks have run by this point so window.state reflects only
        // components that survived the patch — the snapshot is clean.
        if ($8a38739c2dd2509d$var$devToolsConnection) $8a38739c2dd2509d$var$devToolsConnection.send({
            type: "[PATCH]",
            meta: {
                isPatch: true
            }
        }, $8a38739c2dd2509d$var$getAggregatedState());
    },
    subscriptionConnect (id, label) {
        // Send subscription connect to Redux DevTools
        if ($8a38739c2dd2509d$var$devToolsConnection) $8a38739c2dd2509d$var$devToolsConnection.send({
            type: `${id}/[Subscription] ${label}/connect`,
            meta: {
                isSubscription: true,
                status: "connect"
            }
        }, $8a38739c2dd2509d$var$getAggregatedState());
        // Console logging
        if ($8a38739c2dd2509d$var$logEnabled) console.log(`%cSubscription "${label}" connected`, "color: #8d8");
    },
    manualError (id, name) {
        throw Error(`#${id} "${name}" cannot be invoked manually`);
    }
};
function $8a38739c2dd2509d$var$replacer(_k, v) {
    return typeof v === "function" ? "[fn]" : v;
}
window.addEventListener("error", ()=>{
    setTimeout(()=>{
        console.groupEnd();
        $8a38739c2dd2509d$var$groupId = "";
    });
});


var $74be9b19a1366743$export$349167d36ac296fc = /*#__PURE__*/ function(ThunkType) {
    ThunkType[ThunkType["Action"] = 0] = "Action";
    ThunkType[ThunkType["Task"] = 1] = "Task";
    ThunkType[ThunkType["Subscription"] = 2] = "Subscription";
    return ThunkType;
}({});


const $c2ff18708e0ff0b4$export$569cf426fc35a920 = new Map();
const $c2ff18708e0ff0b4$export$75b141ceea91ed1d = new Map();
const $c2ff18708e0ff0b4$export$23a9a5059f52d745 = new Map();
const $c2ff18708e0ff0b4$export$39b1cda6cb2e96ba = new Map();
// Tracks active subscription cleanup functions keyed by "componentId:subscriptionName"
const $c2ff18708e0ff0b4$var$subscriptionCleanups = new Map();
// Tracks which cache keys were referenced during the current root render pass.
// Entries not touched are evicted after patch to prevent unbounded growth from
// dynamic action/task data payloads.
const $c2ff18708e0ff0b4$var$activeThunkKeys = new Set();
// The root component's type is not known until `renderComponent()`
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $c2ff18708e0ff0b4$var$rootAction;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $c2ff18708e0ff0b4$var$rootTask;
let $c2ff18708e0ff0b4$var$rootState;
// Render cycle state
let $c2ff18708e0ff0b4$var$renderingFromRoot = false;
let $c2ff18708e0ff0b4$var$stateChanged = false;
// Tracks state changes that occur *during* a root view call (e.g. a newly-mounted
// child's init action relaying state upward via an ActionThunk prop). Distinct from
// stateChanged so the re-render loop only fires for mid-render mutations, not the
// state change that originally triggered the render.
let $c2ff18708e0ff0b4$var$stateChangedDuringRender = false;
let $c2ff18708e0ff0b4$var$noRender = 0;
const $c2ff18708e0ff0b4$var$appId = "app";
function $c2ff18708e0ff0b4$var$resetAppState() {
    $c2ff18708e0ff0b4$export$569cf426fc35a920.clear();
    $c2ff18708e0ff0b4$export$75b141ceea91ed1d.clear();
    $c2ff18708e0ff0b4$export$23a9a5059f52d745.clear();
    $c2ff18708e0ff0b4$export$39b1cda6cb2e96ba.clear();
    $c2ff18708e0ff0b4$var$subscriptionCleanups.forEach((cleanup)=>cleanup());
    $c2ff18708e0ff0b4$var$subscriptionCleanups.clear();
    $c2ff18708e0ff0b4$var$activeThunkKeys.clear();
    $c2ff18708e0ff0b4$var$rootAction = undefined;
    $c2ff18708e0ff0b4$var$rootTask = undefined;
    $c2ff18708e0ff0b4$var$rootState = undefined;
    $c2ff18708e0ff0b4$var$renderingFromRoot = false;
    $c2ff18708e0ff0b4$var$stateChanged = false;
    $c2ff18708e0ff0b4$var$stateChangedDuringRender = false;
    $c2ff18708e0ff0b4$var$noRender = 0;
}
// Test utilities
let $c2ff18708e0ff0b4$var$internalKey = {};
const $c2ff18708e0ff0b4$export$1df49270ecec55e0 = (k)=>$c2ff18708e0ff0b4$var$internalKey = k;
const $c2ff18708e0ff0b4$export$3f938dd9b29e6a8e = $c2ff18708e0ff0b4$var$resetAppState;
// Helper to create stable cache keys
function $c2ff18708e0ff0b4$var$createCacheKey(id, name, data) {
    const dataKey = data === null || data === undefined ? "" : JSON.stringify(data);
    return `${id}:${name}:${dataKey}`;
}
// Action thunk creator with memoization
function $c2ff18708e0ff0b4$var$createActionThunk(componentId, actionName, data) {
    const cacheKey = $c2ff18708e0ff0b4$var$createCacheKey(componentId, actionName, data);
    $c2ff18708e0ff0b4$var$activeThunkKeys.add(cacheKey);
    const cached = $c2ff18708e0ff0b4$export$75b141ceea91ed1d.get(cacheKey);
    if (cached) return cached;
    const actionThunk = (thunkInput)=>{
        const instance = $c2ff18708e0ff0b4$export$569cf426fc35a920.get(componentId);
        if (!instance) // Component was unmounted - silently ignore (expected for async task callbacks)
        return;
        if ($c2ff18708e0ff0b4$var$isDomEvent(thunkInput)) $c2ff18708e0ff0b4$var$executeAction(instance, actionName, data, thunkInput);
        else if (thunkInput === $c2ff18708e0ff0b4$var$internalKey) $c2ff18708e0ff0b4$var$executeAction(instance, actionName, data);
        else (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).manualError(componentId, actionName);
    };
    actionThunk.type = (0, $74be9b19a1366743$export$349167d36ac296fc).Action;
    $c2ff18708e0ff0b4$export$75b141ceea91ed1d.set(cacheKey, actionThunk);
    return actionThunk;
}
// Task thunk creator with memoization
function $c2ff18708e0ff0b4$var$createTaskThunk(componentId, taskName, data) {
    const cacheKey = $c2ff18708e0ff0b4$var$createCacheKey(componentId, taskName, data);
    $c2ff18708e0ff0b4$var$activeThunkKeys.add(cacheKey);
    const cached = $c2ff18708e0ff0b4$export$23a9a5059f52d745.get(cacheKey);
    if (cached) return cached;
    const taskThunk = (thunkInput)=>{
        if ($c2ff18708e0ff0b4$var$isDomEvent(thunkInput) || thunkInput === $c2ff18708e0ff0b4$var$internalKey) {
            const instance = $c2ff18708e0ff0b4$export$569cf426fc35a920.get(componentId);
            if (!instance) // Component was unmounted - silently ignore (expected for async operations)
            return Promise.resolve();
            const result = $c2ff18708e0ff0b4$var$performTask(instance, taskName, data);
            return result.then((next)=>$c2ff18708e0ff0b4$var$runNext(instance, next));
        } else (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).manualError(componentId, taskName);
    };
    taskThunk.type = (0, $74be9b19a1366743$export$349167d36ac296fc).Task;
    taskThunk.taskName = String(taskName);
    taskThunk.taskData = data;
    $c2ff18708e0ff0b4$export$23a9a5059f52d745.set(cacheKey, taskThunk);
    return taskThunk;
}
// Subscription thunk creator with memoization
function $c2ff18708e0ff0b4$var$createSubscriptionThunk(componentId, subscriptionName, data) {
    const cacheKey = $c2ff18708e0ff0b4$var$createCacheKey(componentId, subscriptionName, data);
    $c2ff18708e0ff0b4$var$activeThunkKeys.add(cacheKey);
    const cached = $c2ff18708e0ff0b4$export$39b1cda6cb2e96ba.get(cacheKey);
    if (cached) return cached;
    const subscriptionThunk = (thunkInput)=>{
        if ($c2ff18708e0ff0b4$var$isDomEvent(thunkInput) || thunkInput === $c2ff18708e0ff0b4$var$internalKey) {
            const instance = $c2ff18708e0ff0b4$export$569cf426fc35a920.get(componentId);
            if (!instance) return;
            $c2ff18708e0ff0b4$var$connectSubscription(instance, subscriptionName, data);
        } else (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).manualError(componentId, subscriptionName);
    };
    subscriptionThunk.type = (0, $74be9b19a1366743$export$349167d36ac296fc).Subscription;
    subscriptionThunk.subscriptionName = String(subscriptionName);
    subscriptionThunk.subscriptionData = data;
    $c2ff18708e0ff0b4$export$39b1cda6cb2e96ba.set(cacheKey, subscriptionThunk);
    return subscriptionThunk;
}
function $c2ff18708e0ff0b4$var$connectSubscription(instance, subscriptionName, data) {
    const { config: config, id: id } = instance;
    const subscriptions = config.subscriptions;
    if (!subscriptions?.[subscriptionName]) throw Error(`Subscription ${subscriptionName} not found in ${id}`);
    const cleanupKey = `${id}:${subscriptionName}`;
    // Tear down existing subscription before replacing
    const existingCleanup = $c2ff18708e0ff0b4$var$subscriptionCleanups.get(cleanupKey);
    if (existingCleanup) {
        existingCleanup();
        $c2ff18708e0ff0b4$var$subscriptionCleanups.delete(cleanupKey);
    }
    const { connect: connect } = subscriptions[subscriptionName](data);
    const runAction = (actionName, actionData)=>{
        const currentInstance = $c2ff18708e0ff0b4$export$569cf426fc35a920.get(id);
        if (currentInstance) $c2ff18708e0ff0b4$var$executeAction(currentInstance, String(actionName), actionData);
    };
    const cleanup = connect(runAction);
    $c2ff18708e0ff0b4$var$subscriptionCleanups.set(cleanupKey, cleanup);
    (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).subscriptionConnect(id, String(subscriptionName));
}
function $c2ff18708e0ff0b4$var$executeAction(instance, actionName, data, event) {
    const { config: config, state: prevState, props: props, isRoot: isRoot, id: id } = instance;
    const actions = config.actions;
    if (!actions?.[actionName]) return;
    const hasStateConfig = Boolean(config.state);
    let next;
    const prevStateFrozen = $c2ff18708e0ff0b4$var$deepFreeze(prevState);
    const actionOutput = actions[actionName](data, {
        id: id,
        props: props ?? {},
        state: prevStateFrozen ?? {},
        rootState: $c2ff18708e0ff0b4$var$rootState ?? {},
        event: event
    });
    // Only update instance.state if component has state config
    if (hasStateConfig) instance.state = actionOutput.state;
    next = actionOutput.next;
    const currStateChanged = hasStateConfig && instance.state !== prevState;
    $c2ff18708e0ff0b4$var$stateChanged = $c2ff18708e0ff0b4$var$stateChanged || currStateChanged;
    if (currStateChanged && $c2ff18708e0ff0b4$var$renderingFromRoot) $c2ff18708e0ff0b4$var$stateChangedDuringRender = true;
    (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).updateStart(id, currStateChanged ? prevState : undefined, actionName, data, instance.state, hasStateConfig);
    if (isRoot) $c2ff18708e0ff0b4$var$rootState = instance.state;
    if (currStateChanged && instance.state) (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).updateEnd(instance.state);
    $c2ff18708e0ff0b4$var$runNext(instance, next);
}
function $c2ff18708e0ff0b4$var$performTask(instance, taskName, data) {
    const { config: config, id: id } = instance;
    const tasks = config.tasks;
    if (!tasks?.[taskName]) throw Error(`Task ${taskName} not found in ${id}`);
    const { perform: perform, success: success, failure: failure } = tasks[taskName](data);
    const runSuccess = (result)=>success?.(result, {
            id: id,
            props: instance.props ?? {},
            state: instance.state ?? {},
            rootState: $c2ff18708e0ff0b4$var$rootState ?? {}
        });
    const runFailure = (err)=>failure?.(err, {
            id: id,
            props: instance.props ?? {},
            state: instance.state ?? {},
            rootState: $c2ff18708e0ff0b4$var$rootState ?? {}
        });
    try {
        const output = perform();
        const isPromise = output instanceof Promise;
        (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).taskPerform(id, String(taskName), isPromise);
        if (isPromise) {
            $c2ff18708e0ff0b4$var$renderComponentInstance(instance); // Render pending state updates
            return output.then((result)=>{
                (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).taskSuccess(id, String(taskName));
                return runSuccess(result);
            }).catch((err)=>{
                (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).taskFailure(id, String(taskName), err);
                return runFailure(err);
            });
        } else {
            (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).taskSuccess(id, String(taskName));
            return Promise.resolve(runSuccess(output));
        }
    } catch (err) {
        (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).taskFailure(id, String(taskName), err);
        return Promise.resolve(runFailure(err));
    }
}
function $c2ff18708e0ff0b4$var$runNext(instance, next) {
    // Check if component still exists before processing next
    if (!$c2ff18708e0ff0b4$export$569cf426fc35a920.has(instance.id)) // Component was unmounted - silently ignore
    return;
    if (!next) $c2ff18708e0ff0b4$var$renderComponentInstance(instance);
    else if ($c2ff18708e0ff0b4$var$isThunk(next)) {
        // Thunks may only be invoked here or from the DOM
        // `internalKey` prevents any manual calls from outside
        next($c2ff18708e0ff0b4$var$internalKey);
        // Actions and tasks re-enter runNext themselves (sync and async respectively).
        // Subscriptions are fire-and-forget — render here.
        if (next.type === (0, $74be9b19a1366743$export$349167d36ac296fc).Subscription) $c2ff18708e0ff0b4$var$renderComponentInstance(instance);
    } else if (Array.isArray(next)) {
        $c2ff18708e0ff0b4$var$noRender++;
        next.forEach((n)=>$c2ff18708e0ff0b4$var$runNext(instance, n));
        $c2ff18708e0ff0b4$var$noRender--;
        $c2ff18708e0ff0b4$var$renderComponentInstance(instance);
    }
}
// Render function - always renders from root to keep vnode tree consistent
function $c2ff18708e0ff0b4$var$renderComponentInstance(instance) {
    if (!$c2ff18708e0ff0b4$var$noRender && ($c2ff18708e0ff0b4$var$stateChanged || instance.props !== instance.prevProps)) {
        let isRenderRoot = false;
        if (!$c2ff18708e0ff0b4$var$renderingFromRoot) {
            // If a child component, start render from root
            const rootInstance = $c2ff18708e0ff0b4$export$569cf426fc35a920.get($c2ff18708e0ff0b4$var$appId);
            if (rootInstance && !instance.isRoot) return $c2ff18708e0ff0b4$var$renderComponentInstance(rootInstance);
            // Already root
            $c2ff18708e0ff0b4$var$renderingFromRoot = true;
            isRenderRoot = true;
        }
        // Mark as rendering to prevent cleanup during patch (destroy hooks may fire)
        instance.inCurrentRender = true;
        const prevVNode = instance.vnode;
        // Reset before each root view call so only state changes occurring *during* view
        // execution (e.g. newly-mounted children relaying init state upward) are detected.
        if (isRenderRoot) {
            $c2ff18708e0ff0b4$var$stateChangedDuringRender = false;
            $c2ff18708e0ff0b4$var$activeThunkKeys.clear();
        }
        (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).render(instance.id, instance.props);
        (0, $f6a8f99a7469fbef$export$ee8240ad80d3fc2c)(true);
        instance.vnode = instance.config.view({
            id: instance.id,
            props: instance.props ?? {},
            state: instance.state ?? {},
            rootState: $c2ff18708e0ff0b4$var$rootState ?? {}
        });
        (0, $f6a8f99a7469fbef$export$ee8240ad80d3fc2c)(false);
        (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).setStateGlobal(instance.id, instance.state);
        // Patch the DOM once at the root
        if (isRenderRoot && prevVNode) {
            // A newly-mounted child's init action may relay state upward via an ActionThunk
            // prop during the view call above, updating instance.state after the view's
            // `state` snapshot was already captured. Re-render until the output stabilises
            // so the DOM reflects the settled state in a single sync patch.
            while($c2ff18708e0ff0b4$var$stateChangedDuringRender){
                $c2ff18708e0ff0b4$var$stateChangedDuringRender = false;
                $c2ff18708e0ff0b4$var$activeThunkKeys.clear();
                Array.from($c2ff18708e0ff0b4$export$569cf426fc35a920.values()).forEach((inst)=>{
                    inst.inCurrentRender = false;
                });
                instance.inCurrentRender = true;
                (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).midRenderStateChange(instance.id, instance.props);
                (0, $f6a8f99a7469fbef$export$ee8240ad80d3fc2c)(true);
                instance.vnode = instance.config.view({
                    id: instance.id,
                    props: instance.props ?? {},
                    state: instance.state ?? {},
                    rootState: $c2ff18708e0ff0b4$var$rootState ?? {}
                });
                (0, $f6a8f99a7469fbef$export$ee8240ad80d3fc2c)(false);
                (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).setStateGlobal(instance.id, instance.state);
            }
            (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).patch();
            (0, $f6a8f99a7469fbef$export$b76953f99ab2be78)(prevVNode, instance.vnode);
            (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).patchComplete();
            $c2ff18708e0ff0b4$export$89b472e03be495df("patch");
            $c2ff18708e0ff0b4$var$stateChanged = false;
            $c2ff18708e0ff0b4$var$renderingFromRoot = false;
            // Reset render flags
            Array.from($c2ff18708e0ff0b4$export$569cf426fc35a920.values()).forEach((inst)=>{
                inst.inCurrentRender = false;
            });
            // Evict thunk cache entries not referenced during this render pass
            $c2ff18708e0ff0b4$export$75b141ceea91ed1d.forEach((_, key)=>{
                if (!$c2ff18708e0ff0b4$var$activeThunkKeys.has(key)) $c2ff18708e0ff0b4$export$75b141ceea91ed1d.delete(key);
            });
            $c2ff18708e0ff0b4$export$23a9a5059f52d745.forEach((_, key)=>{
                if (!$c2ff18708e0ff0b4$var$activeThunkKeys.has(key)) $c2ff18708e0ff0b4$export$23a9a5059f52d745.delete(key);
            });
            $c2ff18708e0ff0b4$export$39b1cda6cb2e96ba.forEach((_, key)=>{
                if (!$c2ff18708e0ff0b4$var$activeThunkKeys.has(key)) $c2ff18708e0ff0b4$export$39b1cda6cb2e96ba.delete(key);
            });
            $c2ff18708e0ff0b4$var$activeThunkKeys.clear();
        }
        $c2ff18708e0ff0b4$var$setCleanup(instance);
    }
    instance.prevProps = instance.props;
    return instance.vnode;
}
function $c2ff18708e0ff0b4$export$d8556a2a8f973135(getConfig) {
    // Pass in callback that returns component config
    // Returns render function that is called by parent e.g. `counter("counter-0", { start: 0 })`
    const renderFn = (idStr, props)=>{
        const id = (idStr || "").replace(/^#/, "");
        // Check if component exists in registry
        const existing = $c2ff18708e0ff0b4$export$569cf426fc35a920.get(id);
        if (!id.length || !$c2ff18708e0ff0b4$var$noRender && existing?.inCurrentRender) throw Error(`Component${id ? ` "${id}" ` : " "}must have a unique id!`);
        // Mark as in current render
        if (existing) existing.inCurrentRender = true;
        return $c2ff18708e0ff0b4$export$fa7f552cb3a457a6(id, getConfig, props);
    };
    // Add a handle to `getConfig` for tests
    renderFn.getConfig = getConfig;
    return renderFn;
}
function $c2ff18708e0ff0b4$export$fa7f552cb3a457a6(id, getConfig, props) {
    $c2ff18708e0ff0b4$var$deepFreeze(props);
    const isRoot = id === $c2ff18708e0ff0b4$var$appId;
    // If component already exists, just render again
    const existingRender = $c2ff18708e0ff0b4$export$569cf426fc35a920.get(id)?.render;
    if (existingRender) {
        const newVNode = existingRender(props);
        if (newVNode) return newVNode;
    }
    const action = (actionName, data)=>{
        return $c2ff18708e0ff0b4$var$createActionThunk(id, String(actionName), data);
    };
    const task = (taskName, data)=>{
        return $c2ff18708e0ff0b4$var$createTaskThunk(id, String(taskName), data);
    };
    const subscription = (subscriptionName, data)=>{
        return $c2ff18708e0ff0b4$var$createSubscriptionThunk(id, String(subscriptionName), data);
    };
    const config = getConfig({
        action: action,
        task: task,
        subscription: subscription,
        // Assert root action/task types from the `Component` type
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        rootAction: $c2ff18708e0ff0b4$var$rootAction,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        rootTask: $c2ff18708e0ff0b4$var$rootTask
    });
    const state = config.state?.(props);
    // Create component instance
    const instance = {
        id: id,
        config: config,
        state: state,
        props: props,
        prevProps: undefined,
        render: (p)=>{
            const inst = $c2ff18708e0ff0b4$export$569cf426fc35a920.get(id);
            if (inst) {
                inst.props = p;
                return $c2ff18708e0ff0b4$var$renderComponentInstance(inst);
            }
        },
        vnode: undefined,
        isRoot: isRoot,
        inCurrentRender: true
    };
    $c2ff18708e0ff0b4$export$569cf426fc35a920.set(id, instance);
    if (config.init) {
        $c2ff18708e0ff0b4$var$noRender++;
        $c2ff18708e0ff0b4$var$runNext(instance, config.init);
        $c2ff18708e0ff0b4$var$noRender--;
    } else (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).noInitialAction(id, state);
    if (isRoot) {
        $c2ff18708e0ff0b4$var$rootAction = action;
        $c2ff18708e0ff0b4$var$rootTask = task;
        $c2ff18708e0ff0b4$var$rootState = instance.state;
    }
    (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).render(id, props);
    (0, $f6a8f99a7469fbef$export$ee8240ad80d3fc2c)(true);
    instance.vnode = config.view({
        id: id,
        props: props ?? {},
        state: instance.state ?? {},
        rootState: $c2ff18708e0ff0b4$var$rootState ?? {}
    });
    (0, $f6a8f99a7469fbef$export$ee8240ad80d3fc2c)(false);
    instance.prevProps = props;
    $c2ff18708e0ff0b4$var$setCleanup(instance);
    (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).setStateGlobal(id, instance.state);
    return instance.vnode;
}
function $c2ff18708e0ff0b4$var$setCleanup(instance) {
    if (!instance.vnode) return;
    const configDestroy = instance.config.destroy;
    // setHook composes with any user-defined destroy hook already on the vnode
    (0, $f6a8f99a7469fbef$export$5833d9be8010042a)(instance.vnode, "destroy", ()=>{
        if (configDestroy) configDestroy();
        const inst = $c2ff18708e0ff0b4$export$569cf426fc35a920.get(instance.id);
        if (inst && !inst.inCurrentRender) {
            $c2ff18708e0ff0b4$export$569cf426fc35a920.delete(instance.id);
            // Tear down active subscriptions
            const prefix = `${instance.id}:`;
            Array.from($c2ff18708e0ff0b4$var$subscriptionCleanups.keys()).forEach((key)=>{
                if (key.startsWith(prefix)) {
                    $c2ff18708e0ff0b4$var$subscriptionCleanups.get(key)?.();
                    $c2ff18708e0ff0b4$var$subscriptionCleanups.delete(key);
                }
            });
            // Clean up thunk caches
            Array.from($c2ff18708e0ff0b4$export$75b141ceea91ed1d.keys()).forEach((key)=>{
                if (key.startsWith(prefix)) $c2ff18708e0ff0b4$export$75b141ceea91ed1d.delete(key);
            });
            Array.from($c2ff18708e0ff0b4$export$23a9a5059f52d745.keys()).forEach((key)=>{
                if (key.startsWith(prefix)) $c2ff18708e0ff0b4$export$23a9a5059f52d745.delete(key);
            });
            Array.from($c2ff18708e0ff0b4$export$39b1cda6cb2e96ba.keys()).forEach((key)=>{
                if (key.startsWith(prefix)) $c2ff18708e0ff0b4$export$39b1cda6cb2e96ba.delete(key);
            });
            (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).setStateGlobal(instance.id, undefined);
        }
    });
}
function $c2ff18708e0ff0b4$export$186d02efde07ef98({ app: app, props: props, init: init }) {
    $c2ff18708e0ff0b4$var$resetAppState();
    // Mount the top-level app component
    const appElement = document.getElementById($c2ff18708e0ff0b4$var$appId);
    if (!appElement) throw Error(`Element with id "${$c2ff18708e0ff0b4$var$appId}" not found`);
    (0, $f6a8f99a7469fbef$export$b76953f99ab2be78)(appElement, app($c2ff18708e0ff0b4$var$appId, props));
    (0, $8a38739c2dd2509d$export$bef1f36f5486a6a3).patch();
    $c2ff18708e0ff0b4$export$89b472e03be495df("patch");
    // Reset render flags
    Array.from($c2ff18708e0ff0b4$export$569cf426fc35a920.values()).forEach((instance)=>{
        instance.inCurrentRender = false;
    });
    // Manually invoking an action without `internalKey` is an error, so `runRootAction`
    // is provided by `mount` for wiring up events to root actions (e.g. routing)
    if (init) {
        const runRootAction = (actionName, data)=>{
            $c2ff18708e0ff0b4$var$rootAction?.(actionName, data)($c2ff18708e0ff0b4$var$internalKey);
        };
        init(runRootAction);
    }
}
function $c2ff18708e0ff0b4$var$isDomEvent(event) {
    return event instanceof Event;
}
function $c2ff18708e0ff0b4$var$isThunk(next) {
    if (next) return !Array.isArray(next) && next.type in (0, $74be9b19a1366743$export$349167d36ac296fc);
    return false;
}
const $c2ff18708e0ff0b4$var$isFreezable = (value)=>value !== null && typeof value === "object" && !Object.isFrozen(value);
function $c2ff18708e0ff0b4$var$freezeRecursive(value) {
    if ($c2ff18708e0ff0b4$var$isFreezable(value)) {
        Object.freeze(value);
        Object.getOwnPropertyNames(value).forEach((p)=>{
            $c2ff18708e0ff0b4$var$freezeRecursive(value[p]);
        });
    }
}
const $c2ff18708e0ff0b4$var$deepFreeze = (o)=>o;
function $c2ff18708e0ff0b4$export$24e6315230045f0a(thunk, options) {
    return (e)=>{
        if (options.preventDefault) e.preventDefault();
        if (options.stopPropagation) e.stopPropagation();
        if (options.stopImmediatePropagation) e.stopImmediatePropagation();
        thunk(e);
    };
}
function $c2ff18708e0ff0b4$export$ec068583843480e7(type, listener) {
    document.addEventListener(type, listener);
}
function $c2ff18708e0ff0b4$export$f500693cef883ffd(type, listener) {
    document.removeEventListener(type, listener);
}
function $c2ff18708e0ff0b4$export$89b472e03be495df(type, detail) {
    document.dispatchEvent(new CustomEvent(type, detail ? {
        detail: detail
    } : undefined));
}


var $f993037a9863bffd$exports = {};
!function(t, n) {
    $f993037a9863bffd$exports = n();
}("undefined" != typeof self ? self : $f993037a9863bffd$exports, function() {
    return function() {
        "use strict";
        var t = {
            407: function(t, n, e) {
                e.d(n, {
                    default: function() {
                        return N;
                    }
                });
                var o = /([:*])(\w+)/g, r = /\*/g, i = /\/\?/g;
                function a(t) {
                    return void 0 === t && (t = "/"), v() ? location.pathname + location.search + location.hash : t;
                }
                function s(t) {
                    return t.replace(/\/+$/, "").replace(/^\/+/, "");
                }
                function c(t) {
                    return "string" == typeof t;
                }
                function u(t) {
                    return t && t.indexOf("#") >= 0 && t.split("#").pop() || "";
                }
                function h(t) {
                    var n = s(t).split(/\?(.*)?$/);
                    return [
                        s(n[0]),
                        n.slice(1).join("")
                    ];
                }
                function f(t) {
                    for(var n = {}, e = t.split("&"), o = 0; o < e.length; o++){
                        var r = e[o].split("=");
                        if ("" !== r[0]) {
                            var i = decodeURIComponent(r[0]);
                            n[i] ? (Array.isArray(n[i]) || (n[i] = [
                                n[i]
                            ]), n[i].push(decodeURIComponent(r[1] || ""))) : n[i] = decodeURIComponent(r[1] || "");
                        }
                    }
                    return n;
                }
                function l(t, n) {
                    var e, a = h(s(t.currentLocationPath)), l = a[0], p = a[1], d = "" === p ? null : f(p), v = [];
                    if (c(n.path)) {
                        if (e = "(?:/^|^)" + s(n.path).replace(o, function(t, n, e) {
                            return v.push(e), "([^/]+)";
                        }).replace(r, "?(?:.*)").replace(i, "/?([^/]+|)") + "$", "" === s(n.path) && "" === s(l)) return {
                            url: l,
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: null,
                            params: d
                        };
                    } else e = n.path;
                    var g = new RegExp(e, ""), m = l.match(g);
                    if (m) {
                        var y = c(n.path) ? function(t, n) {
                            return 0 === n.length ? null : t ? t.slice(1, t.length).reduce(function(t, e, o) {
                                return null === t && (t = {}), t[n[o]] = decodeURIComponent(e), t;
                            }, null) : null;
                        }(m, v) : m.groups ? m.groups : m.slice(1);
                        return {
                            url: s(l.replace(new RegExp("^" + t.instance.root), "")),
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: y,
                            params: d
                        };
                    }
                    return !1;
                }
                function p() {
                    return !("undefined" == typeof window || !window.history || !window.history.pushState);
                }
                function d(t, n) {
                    return void 0 === t[n] || !0 === t[n];
                }
                function v() {
                    return "undefined" != typeof window;
                }
                function g(t, n) {
                    return void 0 === t && (t = []), void 0 === n && (n = {}), t.filter(function(t) {
                        return t;
                    }).forEach(function(t) {
                        [
                            "before",
                            "after",
                            "already",
                            "leave"
                        ].forEach(function(e) {
                            t[e] && (n[e] || (n[e] = []), n[e].push(t[e]));
                        });
                    }), n;
                }
                function m(t, n, e) {
                    var o = n || {}, r = 0;
                    !function n() {
                        t[r] ? Array.isArray(t[r]) ? (t.splice.apply(t, [
                            r,
                            1
                        ].concat(t[r][0](o) ? t[r][1] : t[r][2])), n()) : t[r](o, function(t) {
                            void 0 === t || !0 === t ? (r += 1, n()) : e && e(o);
                        }) : e && e(o);
                    }();
                }
                function y(t, n) {
                    void 0 === t.currentLocationPath && (t.currentLocationPath = t.to = a(t.instance.root)), t.currentLocationPath = t.instance._checkForAHash(t.currentLocationPath), n();
                }
                function _(t, n) {
                    for(var e = 0; e < t.instance.routes.length; e++){
                        var o = l(t, t.instance.routes[e]);
                        if (o && (t.matches || (t.matches = []), t.matches.push(o), "ONE" === t.resolveOptions.strategy)) return void n();
                    }
                    n();
                }
                function k(t, n) {
                    t.navigateOptions && (void 0 !== t.navigateOptions.shouldResolve && console.warn('"shouldResolve" is deprecated. Please check the documentation.'), void 0 !== t.navigateOptions.silent && console.warn('"silent" is deprecated. Please check the documentation.')), n();
                }
                function O(t, n) {
                    !0 === t.navigateOptions.force ? (t.instance._setCurrent([
                        t.instance._pathToMatchObject(t.to)
                    ]), n(!1)) : n();
                }
                m.if = function(t, n, e) {
                    return Array.isArray(n) || (n = [
                        n
                    ]), Array.isArray(e) || (e = [
                        e
                    ]), [
                        t,
                        n,
                        e
                    ];
                };
                var w = v(), L = p();
                function b(t, n) {
                    if (d(t.navigateOptions, "updateBrowserURL")) {
                        var e = ("/" + t.to).replace(/\/\//g, "/"), o = w && t.resolveOptions && !0 === t.resolveOptions.hash;
                        L ? (history[t.navigateOptions.historyAPIMethod || "pushState"](t.navigateOptions.stateObj || {}, t.navigateOptions.title || "", o ? "#" + e : e), location && location.hash && (t.instance.__freezeListening = !0, setTimeout(function() {
                            if (!o) {
                                var n = location.hash;
                                location.hash = "", location.hash = n;
                            }
                            t.instance.__freezeListening = !1;
                        }, 1))) : w && (window.location.href = t.to);
                    }
                    n();
                }
                function A(t, n) {
                    var e = t.instance;
                    e.lastResolved() ? m(e.lastResolved().map(function(n) {
                        return function(e, o) {
                            if (n.route.hooks && n.route.hooks.leave) {
                                var r = !1, i = t.instance.matchLocation(n.route.path, t.currentLocationPath, !1);
                                r = "*" !== n.route.path ? !i : !(t.matches && t.matches.find(function(t) {
                                    return n.route.path === t.route.path;
                                })), d(t.navigateOptions, "callHooks") && r ? m(n.route.hooks.leave.map(function(n) {
                                    return function(e, o) {
                                        return n(function(n) {
                                            !1 === n ? t.instance.__markAsClean(t) : o();
                                        }, t.matches && t.matches.length > 0 ? 1 === t.matches.length ? t.matches[0] : t.matches : void 0);
                                    };
                                }).concat([
                                    function() {
                                        return o();
                                    }
                                ])) : o();
                            } else o();
                        };
                    }), {}, function() {
                        return n();
                    }) : n();
                }
                function P(t, n) {
                    d(t.navigateOptions, "updateState") && t.instance._setCurrent(t.matches), n();
                }
                var R = [
                    function(t, n) {
                        var e = t.instance.lastResolved();
                        if (e && e[0] && e[0].route === t.match.route && e[0].url === t.match.url && e[0].queryString === t.match.queryString) return e.forEach(function(n) {
                            n.route.hooks && n.route.hooks.already && d(t.navigateOptions, "callHooks") && n.route.hooks.already.forEach(function(n) {
                                return n(t.match);
                            });
                        }), void n(!1);
                        n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.before && d(t.navigateOptions, "callHooks") ? m(t.match.route.hooks.before.map(function(n) {
                            return function(e, o) {
                                return n(function(n) {
                                    !1 === n ? t.instance.__markAsClean(t) : o();
                                }, t.match);
                            };
                        }).concat([
                            function() {
                                return n();
                            }
                        ])) : n();
                    },
                    function(t, n) {
                        d(t.navigateOptions, "callHandler") && t.match.route.handler(t.match), t.instance.updatePageLinks(), n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.after && d(t.navigateOptions, "callHooks") && t.match.route.hooks.after.forEach(function(n) {
                            return n(t.match);
                        }), n();
                    }
                ], S = [
                    A,
                    function(t, n) {
                        var e = t.instance._notFoundRoute;
                        if (e) {
                            t.notFoundHandled = !0;
                            var o = h(t.currentLocationPath), r = o[0], i = o[1], a = u(t.to);
                            e.path = s(r);
                            var c = {
                                url: e.path,
                                queryString: i,
                                hashString: a,
                                data: null,
                                route: e,
                                params: "" !== i ? f(i) : null
                            };
                            t.matches = [
                                c
                            ], t.match = c;
                        }
                        n();
                    },
                    m.if(function(t) {
                        return t.notFoundHandled;
                    }, R.concat([
                        P
                    ]), [
                        function(t, n) {
                            t.resolveOptions && !1 !== t.resolveOptions.noMatchWarning && void 0 !== t.resolveOptions.noMatchWarning || console.warn('Navigo: "' + t.currentLocationPath + "\" didn't match any of the registered routes."), n();
                        },
                        function(t, n) {
                            t.instance._setCurrent(null), n();
                        }
                    ])
                ];
                function E() {
                    return (E = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                function x(t, n) {
                    var e = 0;
                    A(t, function o() {
                        e !== t.matches.length ? m(R, E({}, t, {
                            match: t.matches[e]
                        }), function() {
                            e += 1, o();
                        }) : P(t, n);
                    });
                }
                function H(t) {
                    t.instance.__markAsClean(t);
                }
                function j() {
                    return (j = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                var C = "[data-navigo]";
                function N(t, n) {
                    var e, o = n || {
                        strategy: "ONE",
                        hash: !1,
                        noMatchWarning: !1,
                        linksSelector: C
                    }, r = this, i = "/", d = null, w = [], L = !1, A = p(), P = v();
                    function R(t) {
                        return t.indexOf("#") >= 0 && (t = !0 === o.hash ? t.split("#")[1] || "/" : t.split("#")[0]), t;
                    }
                    function E(t) {
                        return s(i + "/" + s(t));
                    }
                    function N(t, n, e, o) {
                        return t = c(t) ? E(t) : t, {
                            name: o || s(String(t)),
                            path: t,
                            handler: n,
                            hooks: g(e)
                        };
                    }
                    function U(t, n) {
                        if (!r.__dirty) {
                            r.__dirty = !0, t = t ? s(i) + "/" + s(t) : void 0;
                            var e = {
                                instance: r,
                                to: t,
                                currentLocationPath: t,
                                navigateOptions: {},
                                resolveOptions: j({}, o, n)
                            };
                            return m([
                                y,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S)
                            ], e, H), !!e.matches && e.matches;
                        }
                        r.__waiting.push(function() {
                            return r.resolve(t, n);
                        });
                    }
                    function q(t, n) {
                        if (r.__dirty) r.__waiting.push(function() {
                            return r.navigate(t, n);
                        });
                        else {
                            r.__dirty = !0, t = s(i) + "/" + s(t);
                            var e = {
                                instance: r,
                                to: t,
                                navigateOptions: n || {},
                                resolveOptions: n && n.resolveOptions ? n.resolveOptions : o,
                                currentLocationPath: R(t)
                            };
                            m([
                                k,
                                O,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S),
                                b,
                                H
                            ], e, H);
                        }
                    }
                    function F() {
                        if (P) return (P ? [].slice.call(document.querySelectorAll(o.linksSelector || C)) : []).forEach(function(t) {
                            "false" !== t.getAttribute("data-navigo") && "_blank" !== t.getAttribute("target") ? t.hasListenerAttached || (t.hasListenerAttached = !0, t.navigoHandler = function(n) {
                                if ((n.ctrlKey || n.metaKey) && "a" === n.target.tagName.toLowerCase()) return !1;
                                var e = t.getAttribute("href");
                                if (null == e) return !1;
                                if (e.match(/^(http|https)/) && "undefined" != typeof URL) try {
                                    var o = new URL(e);
                                    e = o.pathname + o.search;
                                } catch (t) {}
                                var i = function(t) {
                                    if (!t) return {};
                                    var n, e = t.split(","), o = {};
                                    return e.forEach(function(t) {
                                        var e = t.split(":").map(function(t) {
                                            return t.replace(/(^ +| +$)/g, "");
                                        });
                                        switch(e[0]){
                                            case "historyAPIMethod":
                                                o.historyAPIMethod = e[1];
                                                break;
                                            case "resolveOptionsStrategy":
                                                n || (n = {}), n.strategy = e[1];
                                                break;
                                            case "resolveOptionsHash":
                                                n || (n = {}), n.hash = "true" === e[1];
                                                break;
                                            case "updateBrowserURL":
                                            case "callHandler":
                                            case "updateState":
                                            case "force":
                                                o[e[0]] = "true" === e[1];
                                        }
                                    }), n && (o.resolveOptions = n), o;
                                }(t.getAttribute("data-navigo-options"));
                                L || (n.preventDefault(), n.stopPropagation(), r.navigate(s(e), i));
                            }, t.addEventListener("click", t.navigoHandler)) : t.hasListenerAttached && t.removeEventListener("click", t.navigoHandler);
                        }), r;
                    }
                    function I(t, n, e) {
                        var o = w.find(function(n) {
                            return n.name === t;
                        }), r = null;
                        if (o) {
                            if (r = o.path, n) for(var a in n)r = r.replace(":" + a, n[a]);
                            r = r.match(/^\//) ? r : "/" + r;
                        }
                        return r && e && !e.includeRoot && (r = r.replace(new RegExp("^/" + i), "")), r;
                    }
                    function M(t) {
                        var n = h(s(t)), o = n[0], r = n[1], i = "" === r ? null : f(r);
                        return {
                            url: o,
                            queryString: r,
                            hashString: u(t),
                            route: N(o, function() {}, [
                                e
                            ], o),
                            data: null,
                            params: i
                        };
                    }
                    function T(t, n, e) {
                        return "string" == typeof n && (n = z(n)), n ? (n.hooks[t] || (n.hooks[t] = []), n.hooks[t].push(e), function() {
                            n.hooks[t] = n.hooks[t].filter(function(t) {
                                return t !== e;
                            });
                        }) : (console.warn("Route doesn't exists: " + n), function() {});
                    }
                    function z(t) {
                        return "string" == typeof t ? w.find(function(n) {
                            return n.name === E(t);
                        }) : w.find(function(n) {
                            return n.handler === t;
                        });
                    }
                    t ? i = s(t) : console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'), this.root = i, this.routes = w, this.destroyed = L, this.current = d, this.__freezeListening = !1, this.__waiting = [], this.__dirty = !1, this.__markAsClean = function(t) {
                        t.instance.__dirty = !1, t.instance.__waiting.length > 0 && t.instance.__waiting.shift()();
                    }, this.on = function(t, n, o) {
                        var r = this;
                        return "object" != typeof t || t instanceof RegExp ? ("function" == typeof t && (o = n, n = t, t = i), w.push(N(t, n, [
                            e,
                            o
                        ])), this) : (Object.keys(t).forEach(function(n) {
                            if ("function" == typeof t[n]) r.on(n, t[n]);
                            else {
                                var o = t[n], i = o.uses, a = o.as, s = o.hooks;
                                w.push(N(n, i, [
                                    e,
                                    s
                                ], a));
                            }
                        }), this);
                    }, this.off = function(t) {
                        return this.routes = w = w.filter(function(n) {
                            return c(t) ? s(n.path) !== s(t) : "function" == typeof t ? t !== n.handler : String(n.path) !== String(t);
                        }), this;
                    }, this.resolve = U, this.navigate = q, this.navigateByName = function(t, n, e) {
                        var o = I(t, n);
                        return null !== o && (q(o.replace(new RegExp("^/?" + i), ""), e), !0);
                    }, this.destroy = function() {
                        this.routes = w = [], A && window.removeEventListener("popstate", this.__popstateListener), this.destroyed = L = !0;
                    }, this.notFound = function(t, n) {
                        return r._notFoundRoute = N("*", t, [
                            e,
                            n
                        ], "__NOT_FOUND__"), this;
                    }, this.updatePageLinks = F, this.link = function(t) {
                        return "/" + i + "/" + s(t);
                    }, this.hooks = function(t) {
                        return e = t, this;
                    }, this.extractGETParameters = function(t) {
                        return h(R(t));
                    }, this.lastResolved = function() {
                        return d;
                    }, this.generate = I, this.getLinkPath = function(t) {
                        return t.getAttribute("href");
                    }, this.match = function(t) {
                        var n = {
                            instance: r,
                            currentLocationPath: t,
                            to: t,
                            navigateOptions: {},
                            resolveOptions: o
                        };
                        return _(n, function() {}), !!n.matches && n.matches;
                    }, this.matchLocation = function(t, n, e) {
                        void 0 === n || void 0 !== e && !e || (n = E(n));
                        var o = {
                            instance: r,
                            to: n,
                            currentLocationPath: n
                        };
                        return y(o, function() {}), "string" == typeof t && (t = void 0 === e || e ? E(t) : t), l(o, {
                            name: String(t),
                            path: t,
                            handler: function() {},
                            hooks: {}
                        }) || !1;
                    }, this.getCurrentLocation = function() {
                        return M(s(a(i)).replace(new RegExp("^" + i), ""));
                    }, this.addBeforeHook = T.bind(this, "before"), this.addAfterHook = T.bind(this, "after"), this.addAlreadyHook = T.bind(this, "already"), this.addLeaveHook = T.bind(this, "leave"), this.getRoute = z, this._pathToMatchObject = M, this._clean = s, this._checkForAHash = R, this._setCurrent = function(t) {
                        return d = r.current = t;
                    }, (function() {
                        A && (this.__popstateListener = function() {
                            r.__freezeListening || U();
                        }, window.addEventListener("popstate", this.__popstateListener));
                    }).call(this), F.call(this);
                }
            }
        }, n = {};
        function e(o) {
            if (n[o]) return n[o].exports;
            var r = n[o] = {
                exports: {}
            };
            return t[o](r, r.exports, e), r.exports;
        }
        return e.d = function(t, n) {
            for(var o in n)e.o(n, o) && !e.o(t, o) && Object.defineProperty(t, o, {
                enumerable: !0,
                get: n[o]
            });
        }, e.o = function(t, n) {
            return Object.prototype.hasOwnProperty.call(t, n);
        }, e(407);
    }().default;
});






const { div: $655db42a9128d84e$var$div, button: $655db42a9128d84e$var$button } = (0, $f6a8f99a7469fbef$export$c0bb0b647f701bb5);
var $655db42a9128d84e$export$2e2bcd8739ae039 = (0, $c2ff18708e0ff0b4$export$d8556a2a8f973135)(({ action: action })=>({
        state: ()=>({
                show: true
            }),
        actions: {
            Dismiss: (_, { props: props, state: state })=>{
                return {
                    state: {
                        ...state,
                        show: false
                    },
                    next: props.onDismiss
                };
            }
        },
        view ({ id: id, props: props, state: state }) {
            return $655db42a9128d84e$var$div(`#${id}.notification`, {
                class: {
                    show: state.show && props.text.length
                }
            }, [
                props.text,
                $655db42a9128d84e$var$button({
                    on: {
                        click: action("Dismiss")
                    }
                }, "Dismiss")
            ]);
        }
    }));


function $082b3aa23540fed4$export$61471e4a4266e4b9(num) {
    return new Promise((resolve)=>{
        // Mock async
        setTimeout(()=>resolve({
                text: num % 2 === 0 ? "\u2713 Even" : "x Odd"
            }), 500);
    });
}


const { div: $009c9d9a22807449$var$div, button: $009c9d9a22807449$var$button } = (0, $f6a8f99a7469fbef$export$c0bb0b647f701bb5);
var $009c9d9a22807449$export$2e2bcd8739ae039 = (0, $c2ff18708e0ff0b4$export$d8556a2a8f973135)(({ action: action, task: task })=>({
        state: (props)=>({
                count: props.start,
                feedback: ""
            }),
        init: action("Validate"),
        actions: {
            Increment: ({ step: step }, { state: state })=>{
                return {
                    state: {
                        ...state,
                        count: state.count + step
                    },
                    next: action("Validate")
                };
            },
            Decrement: ({ step: step }, { state: state })=>{
                return {
                    state: {
                        ...state,
                        count: state.count - step
                    },
                    next: action("Validate")
                };
            },
            Validate: (_, { state: state, props: props })=>{
                return {
                    state: state,
                    next: [
                        action("SetFeedback", {
                            text: "Validating..."
                        }),
                        // An async task
                        task("ValidateCount", {
                            count: state.count
                        }),
                        // A parent action
                        props.setParentCount(state.count)
                    ]
                };
            },
            SetFeedback: ({ text: text }, { state: state })=>{
                return {
                    state: text === state.feedback ? state : {
                        ...state,
                        feedback: text
                    }
                };
            }
        },
        tasks: {
            ValidateCount: ({ count: count })=>{
                return {
                    perform: ()=>(0, $082b3aa23540fed4$export$61471e4a4266e4b9)(count),
                    success: (result)=>action("SetFeedback", result),
                    failure: ()=>action("SetFeedback", {
                            text: "Unavailable"
                        })
                };
            }
        },
        view ({ id: id, state: state }) {
            return $009c9d9a22807449$var$div(`#${id}.counter`, [
                $009c9d9a22807449$var$button({
                    on: {
                        click: action("Increment", {
                            step: 1
                        })
                    }
                }, "+"),
                $009c9d9a22807449$var$div(String(state.count)),
                $009c9d9a22807449$var$button({
                    on: {
                        click: action("Decrement", {
                            step: 1
                        })
                    }
                }, "-"),
                // Child component - `notification` module
                (0, $655db42a9128d84e$export$2e2bcd8739ae039)(`#${id}-feedback`, {
                    text: state.feedback,
                    onDismiss: action("SetFeedback", {
                        text: ""
                    })
                })
            ]);
        }
    }));



const { div: $0bb25d5219058794$var$div } = (0, $f6a8f99a7469fbef$export$c0bb0b647f701bb5);
var $0bb25d5219058794$export$2e2bcd8739ae039 = (0, $c2ff18708e0ff0b4$export$d8556a2a8f973135)(({ action: action, task: task })=>({
        state: ()=>({
                dragging: false,
                x: 40,
                y: 550,
                offsetX: 0,
                offsetY: 0
            }),
        actions: {
            DragStart: ({ elementId: elementId }, { state: state, event: event })=>{
                return {
                    state: {
                        ...state,
                        dragging: true,
                        offsetX: (event?.clientX ?? 0) - state.x,
                        offsetY: (event?.clientY ?? 0) - state.y
                    },
                    next: task("CapturePointer", {
                        pointerId: event?.pointerId ?? 0,
                        elementId: elementId
                    })
                };
            },
            DragMove: (_, { state: state, event: event })=>{
                if (!state.dragging) return {
                    state: state
                };
                return {
                    state: {
                        ...state,
                        x: (event?.clientX ?? state.x) - state.offsetX,
                        y: (event?.clientY ?? state.y) - state.offsetY
                    }
                };
            },
            DragEnd: (_, { state: state })=>({
                    state: state.dragging ? {
                        ...state,
                        dragging: false
                    } : state
                })
        },
        tasks: {
            CapturePointer: ({ pointerId: pointerId, elementId: elementId })=>({
                    perform: ()=>{
                        document.getElementById(elementId)?.setPointerCapture(pointerId);
                    }
                })
        },
        view ({ id: id, state: state, props: props }) {
            return $0bb25d5219058794$var$div(`#${id}.draggable-total`, {
                style: {
                    left: `${state.x}px`,
                    top: `${state.y}px`,
                    cursor: state.dragging ? "grabbing" : "grab"
                },
                on: {
                    pointerdown: (0, $c2ff18708e0ff0b4$export$24e6315230045f0a)(action("DragStart", {
                        elementId: id
                    }), {
                        preventDefault: true
                    }),
                    pointermove: action("DragMove"),
                    pointerup: action("DragEnd"),
                    pointercancel: action("DragEnd")
                }
            }, `Total: ${props.total}`);
        }
    }));



const { div: $4eca49dec248c5bd$var$div, button: $4eca49dec248c5bd$var$button } = (0, $f6a8f99a7469fbef$export$c0bb0b647f701bb5);
var $4eca49dec248c5bd$export$2e2bcd8739ae039 = (0, $c2ff18708e0ff0b4$export$d8556a2a8f973135)(({ rootAction: rootAction })=>({
        view ({ id: id }) {
            return $4eca49dec248c5bd$var$div(`#${id}`, [
                $4eca49dec248c5bd$var$button({
                    on: {
                        click: rootAction("SetTheme", {
                            theme: "light"
                        })
                    }
                }, "Light theme"),
                $4eca49dec248c5bd$var$button({
                    on: {
                        click: rootAction("SetTheme", {
                            theme: "dark"
                        })
                    }
                }, "Dark theme")
            ]);
        }
    }));



const { button: $175ab20a83df42f1$var$button } = (0, $f6a8f99a7469fbef$export$c0bb0b647f701bb5);
var $175ab20a83df42f1$export$2e2bcd8739ae039 = (0, $c2ff18708e0ff0b4$export$d8556a2a8f973135)(({ action: action, rootAction: rootAction, rootTask: rootTask })=>({
        actions: {
            Like: (_, { props: props, state: state })=>({
                    state: state,
                    next: [
                        rootAction("Like", {
                            page: props.page
                        }),
                        rootTask("SetDocTitle", {
                            title: "You like this!"
                        })
                    ]
                })
        },
        view: ({ id: id, props: props, rootState: rootState })=>$175ab20a83df42f1$var$button(`#${id}.like`, {
                on: {
                    click: action("Like")
                }
            }, `\u{1F44D} ${rootState.likes[props.page]}`)
    }));


const { div: $78df808425b4f682$var$div, span: $78df808425b4f682$var$span, a: $78df808425b4f682$var$a } = (0, $f6a8f99a7469fbef$export$c0bb0b647f701bb5);
var $78df808425b4f682$export$2e2bcd8739ae039 = (0, $c2ff18708e0ff0b4$export$d8556a2a8f973135)(({ action: action, rootTask: rootTask })=>({
        init: rootTask("SetDocTitle", {
            title: "Counter Page"
        }),
        state: ()=>({
                counts: [
                    0,
                    0
                ]
            }),
        actions: {
            SetCount: ({ index: index, count: count }, { state: state })=>{
                return {
                    state: {
                        ...state,
                        counts: {
                            ...state.counts,
                            [index]: count
                        }
                    }
                };
            }
        },
        view ({ id: id, state: state }) {
            return $78df808425b4f682$var$div(`#${id}`, [
                $78df808425b4f682$var$div(".content", [
                    (0, $4eca49dec248c5bd$export$2e2bcd8739ae039)("#theme-menu"),
                    $78df808425b4f682$var$div(".nav", [
                        $78df808425b4f682$var$span("counter page | "),
                        $78df808425b4f682$var$a({
                            attrs: {
                                href: `/list${location.search}`,
                                "data-navigo": true
                            }
                        }, "list page")
                    ]),
                    (0, $175ab20a83df42f1$export$2e2bcd8739ae039)("#counter-like", {
                        page: "counterPage"
                    })
                ]),
                (0, $009c9d9a22807449$export$2e2bcd8739ae039)("#counter-0", {
                    start: 0,
                    setParentCount: (count)=>action("SetCount", {
                            index: 0,
                            count: count
                        })
                }),
                (0, $009c9d9a22807449$export$2e2bcd8739ae039)("#counter-1", {
                    start: -1,
                    setParentCount: (count)=>action("SetCount", {
                            index: 1,
                            count: count
                        })
                }),
                (0, $0bb25d5219058794$export$2e2bcd8739ae039)("#draggable-total", {
                    total: Object.values(state.counts).reduce((acc, count)=>acc + count, 0)
                })
            ]);
        }
    }));






const { div: $e4819008eec420d4$var$div, input: $e4819008eec420d4$var$input, ul: $e4819008eec420d4$var$ul, li: $e4819008eec420d4$var$li, button: $e4819008eec420d4$var$button } = (0, $f6a8f99a7469fbef$export$c0bb0b647f701bb5);
const $e4819008eec420d4$var$allDates = (()=>{
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const days = new Date(year, month + 1, 0).getDate();
    return Array.from({
        length: days
    }, (_, i)=>{
        const date = new Date(year, month, i + 1);
        return {
            id: date.toISOString().split("T")[0],
            label: date.toLocaleDateString("en-US", {
                weekday: "long",
                day: "numeric"
            })
        };
    });
})();
const $e4819008eec420d4$var$filterDates = (filter)=>filter.trim() ? $e4819008eec420d4$var$allDates.filter((d)=>d.label.toLowerCase().includes(filter.toLowerCase().trim())) : $e4819008eec420d4$var$allDates;
// Memoized list view
const $e4819008eec420d4$var$listView = (0, $f6a8f99a7469fbef$export$7c73462e0d25e514)(({ filter: filter, selected: selected, onClick: onClick })=>{
    return $e4819008eec420d4$var$ul(".dates-list", {
        on: {
            click: onClick
        }
    }, $e4819008eec420d4$var$filterDates(filter).map((d)=>$e4819008eec420d4$var$li({
            key: d.id,
            attrs: {
                "data-id": d.id
            },
            class: {
                selected: selected === d.id
            }
        }, d.label)));
});
var $e4819008eec420d4$export$2e2bcd8739ae039 = (0, $c2ff18708e0ff0b4$export$d8556a2a8f973135)(({ action: action })=>({
        state: ()=>({
                filterText: "",
                selectedDate: null,
                showInfo: true
            }),
        actions: {
            SetFilter: (_, { state: state, event: event })=>({
                    state: {
                        ...state,
                        filterText: event?.target?.value ?? ""
                    }
                }),
            SelectDate: (_, { state: state, event: event })=>{
                const id = event?.target instanceof Element ? event.target.closest("[data-id]")?.getAttribute("data-id") : null;
                return id && id !== state.selectedDate ? {
                    state: {
                        ...state,
                        selectedDate: id
                    }
                } : {
                    state: state
                };
            },
            ToggleInfo: (_, { state: state })=>({
                    state: {
                        ...state,
                        showInfo: !state.showInfo
                    }
                })
        },
        view ({ id: id, state: state }) {
            const filtered = $e4819008eec420d4$var$filterDates(state.filterText);
            return $e4819008eec420d4$var$div(`#${id}.dates-picker`, [
                $e4819008eec420d4$var$div(".ui-row", [
                    $e4819008eec420d4$var$input(`#${id}-filter`, {
                        props: {
                            type: "text",
                            value: state.filterText,
                            placeholder: "Filter by day or date..."
                        },
                        on: {
                            input: action("SetFilter")
                        }
                    })
                ]),
                $e4819008eec420d4$var$div(".ui-row", [
                    $e4819008eec420d4$var$button(".help-toggle", {
                        on: {
                            click: action("ToggleInfo")
                        }
                    }, "\u24D8"),
                    state.showInfo ? $e4819008eec420d4$var$div(".dates-info", `Showing ${filtered.length} of ${$e4819008eec420d4$var$allDates.length} days`) : null
                ]),
                // Memoized: re-renders on filter/selection change, but NOT when toggling info
                $e4819008eec420d4$var$listView({
                    filter: state.filterText,
                    selected: state.selectedDate,
                    onClick: action("SelectDate")
                })
            ]);
        }
    }));


const { div: $811c405b34df6706$var$div, span: $811c405b34df6706$var$span, a: $811c405b34df6706$var$a } = (0, $f6a8f99a7469fbef$export$c0bb0b647f701bb5);
var $811c405b34df6706$export$2e2bcd8739ae039 = (0, $c2ff18708e0ff0b4$export$d8556a2a8f973135)(({ rootTask: rootTask })=>({
        init: rootTask("SetDocTitle", {
            title: "List Page"
        }),
        view ({ id: id }) {
            return $811c405b34df6706$var$div(`#${id}`, $811c405b34df6706$var$div(".content", [
                (0, $4eca49dec248c5bd$export$2e2bcd8739ae039)("#theme-menu"),
                $811c405b34df6706$var$div(".nav", [
                    $811c405b34df6706$var$a({
                        attrs: {
                            href: `/counter${location.search}`,
                            "data-navigo": true
                        }
                    }, "counter page"),
                    $811c405b34df6706$var$span(" | list page")
                ]),
                (0, $175ab20a83df42f1$export$2e2bcd8739ae039)("#list-like", {
                    page: "listPage"
                }),
                (0, $e4819008eec420d4$export$2e2bcd8739ae039)("#dates-list")
            ]));
        }
    }));



// Drop-in fake for `new WebSocket(url)` for demo
class $3971dff100f318ce$export$7957e8918b59d9e {
    onmessage = null;
    interval = null;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor(url){
        this.interval = setInterval(()=>{
            this.onmessage?.({
                data: new Date().toLocaleTimeString()
            });
        }, 1000);
    }
    close() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
}


const { div: $b3c037dae7cd6b54$var$div } = (0, $f6a8f99a7469fbef$export$c0bb0b647f701bb5);
var $b3c037dae7cd6b54$export$2e2bcd8739ae039 = (0, $c2ff18708e0ff0b4$export$d8556a2a8f973135)(({ subscription: subscription })=>({
        state: ()=>({
                time: ""
            }),
        init: subscription("Clock"),
        actions: {
            OnTick: ({ time: time }, { state: state })=>({
                    state: {
                        ...state,
                        time: time
                    }
                })
        },
        subscriptions: {
            Clock: ()=>({
                    connect: (runAction)=>{
                        const ws = new (0, $3971dff100f318ce$export$7957e8918b59d9e)("wss://example.com/clock");
                        ws.onmessage = (event)=>runAction("OnTick", {
                                time: event.data
                            });
                        return ()=>ws.close();
                    }
                })
        },
        view: ({ id: id, state: state })=>$b3c037dae7cd6b54$var$div(`#${id}.clock`, state.time)
    }));


const { div: $f43313d21d3fd8e2$var$div } = (0, $f6a8f99a7469fbef$export$c0bb0b647f701bb5);
var $f43313d21d3fd8e2$export$2e2bcd8739ae039 = (0, $c2ff18708e0ff0b4$export$d8556a2a8f973135)(()=>({
        state: ()=>({
                theme: "dark",
                page: undefined,
                likes: {
                    counterPage: 0,
                    listPage: 0
                }
            }),
        actions: {
            SetPage: ({ page: page }, { state: state })=>{
                return {
                    state: page === state.page ? state : {
                        ...state,
                        page: page
                    }
                };
            },
            SetTheme: ({ theme: theme }, { state: state })=>{
                return {
                    state: theme === state.theme ? state : {
                        ...state,
                        theme: theme
                    }
                };
            },
            Like: ({ page: page }, { state: state })=>{
                return {
                    state: {
                        ...state,
                        likes: {
                            ...state.likes,
                            [page]: state.likes[page] + 1
                        }
                    }
                };
            }
        },
        tasks: {
            // Demonstrates a task that is only an effect
            SetDocTitle: ({ title: title })=>({
                    perform: ()=>{
                        document.title = title;
                    }
                })
        },
        view ({ id: id, state: state }) {
            return $f43313d21d3fd8e2$var$div(`#${id}.page`, {
                class: {
                    light: state.theme === "light",
                    dark: state.theme === "dark"
                }
            }, [
                (()=>{
                    switch(state.page){
                        case "listPage":
                            return (0, $811c405b34df6706$export$2e2bcd8739ae039)("#list-page");
                        case "counterPage":
                            return (0, $78df808425b4f682$export$2e2bcd8739ae039)("#counter-page");
                    }
                })(),
                (0, $b3c037dae7cd6b54$export$2e2bcd8739ae039)("#clock")
            ]);
        }
    }));


const $f8409e0880c5cb17$export$66b32f6f30eb4b4 = {
    list: (runRootAction)=>runRootAction("SetPage", {
            page: "listPage"
        }),
    counter: (runRootAction)=>runRootAction("SetPage", {
            page: "counterPage"
        }),
    "*": (runRootAction)=>runRootAction("SetPage", {
            page: "counterPage"
        })
};


const $b4e14b6b8da86996$var$router = new (0, (/*@__PURE__*/$parcel$interopDefault($f993037a9863bffd$exports)))("/demos/cr-26/spa/");
document.addEventListener("DOMContentLoaded", ()=>(0, $c2ff18708e0ff0b4$export$186d02efde07ef98)({
        app: $f43313d21d3fd8e2$export$2e2bcd8739ae039,
        props: {},
        // Manually invoking an action is an error, so `runRootAction` is provided
        // by `mount` for wiring up events to root actions (e.g. routing)
        init: (runRootAction)=>{
            const routeHandlers = Object.entries((0, $f8409e0880c5cb17$export$66b32f6f30eb4b4)).reduce((acc, [path, handler])=>({
                    ...acc,
                    [path]: ()=>handler(runRootAction)
                }), {});
            $b4e14b6b8da86996$var$router.on(routeHandlers).resolve();
            (0, $c2ff18708e0ff0b4$export$ec068583843480e7)("patch", ()=>{
                $b4e14b6b8da86996$var$router.updatePageLinks();
            });
        }
    }));


//# sourceMappingURL=spa.5901bb73.js.map
